import { TimeZones, BarbHelper, Color, ElementSelect, RadioSelect, LiveCatalog} from './types';
import moment from "moment-timezone";
import kt5 from './assets/images/five5kt.png';
import kt10 from './assets/images/ten10kt.png';
import kt15 from './assets/images/fifteen15kt.png';
import kt20 from './assets/images/twenty20kt.png';
import kt25 from './assets/images/twentyfive25kt.png';
import kt30 from './assets/images/thirty30kt.png';
import kt35 from './assets/images/thirtyfive35kt.png';
import kt40 from './assets/images/forty40kt.png';
import kt45 from './assets/images/fortyfive45kt.png';
import kt50 from './assets/images/fifty50kt.png';
import kt55 from './assets/images/fiftyfive55kt.png';
import kt60 from './assets/images/sixty60kt.png';
import kt65 from './assets/images/sixtyfive65kt.png';
import kt70 from './assets/images/seventy70kt.png';
import kt75 from './assets/images/seventyfive75kt.png';
import kt80 from './assets/images/eighty80kt.png';
import kt85 from './assets/images/eightyfive85kt.png';
import kt90 from './assets/images/ninety90kt.png';
import kt95 from './assets/images/ninetyfive95kt.png';
import kt100 from './assets/images/onehundred100kt.png';
import kt105 from './assets/images/hundredfive105kts.png';
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";

let updatedRedirectUri: string;
const redirectUri = process.env.REACT_APP_REDIRECT_URI;
if (redirectUri) {
  updatedRedirectUri = redirectUri.split('/').slice(0, -1).join('/') + '/help';
} else {
  updatedRedirectUri = '#'; // Use a default value if redirectUri is undefined
};

export const fuelCatalogAuditFields =[{
  uiName: 'Fuel Model Catalog Name',
  dbName: 'catalogName'
},{
  uiName: 'fuel model',
  dbName: 'fuelModel'
},{
  uiName: 'grass type',
  dbName: 'grassType'
},{
  uiName: 'mxd override',
  dbName: 'mxdOverride'
},{
  uiName: 'scm',
  dbName: 'scm'
},{
  uiName: 'Drought Catalog ID',
  dbName: 'droughtCatalogId'
},
{
  uiName: 'Live Fuel Catalog ID',
  dbName: 'liveFuelCatalogId'
},{
  uiName: 'Dead Fuel Catalog ID',
  dbName: 'deadFuelCatalogId'
},];
export const deadCatalogAuditFields =[{
  uiName: 'Dead Catalog Name',
  dbName: 'name'
},{
  uiName: '1 HR Fuel Moisture',
  dbName: 'hr1StickRadius'
},{
  uiName: '10 HR Fuel Moisture',
  dbName: 'hr10StickRadius'
},{
  uiName: '100 HR Fuel Moisture',
  dbName: 'hr100StickRadius'
},{
  uiName: '1000 HR Fuel Moisture',
  dbName: 'hr1000StickRadius'
},{
  uiName: '1 HR Fuel Moisture',
  dbName: 'stick_radius_1_hr_fuel_moisture'
},{
  uiName: '10 HR Fuel Moisture',
  dbName: 'stick_radius_10_hr_fuel_moisture'
},{
  uiName: '100 HR Fuel Moisture',
  dbName: 'stick_radius_100_hr_fuel_moisture'
},{
  uiName: '1000 HR Fuel Moisture',
  dbName: 'stick_radius_1000_hr_fuel_moisture'
}];

export const droughtCatalogAuditFields =[{
  uiName: 'Drought Catalog Name',
  dbName: 'description'
},{
  uiName: 'KBDI Threshold',
  dbName: 'kbdi_threshold'
},{
  uiName: 'Initial KBDI',
  dbName: 'kbdi_initial'
},{
  uiName: 'Drought Catalog Name',
  dbName: 'catalogName'
},{
  uiName: 'KBDI Threshold',
  dbName: 'kbdiThreshold'
},{
  uiName: 'Initial KBDI',
  dbName: 'kbdiInitial'
}];

export const liveCatalogAuditFields=[
{
  uiName: 'Live Catalog Catalog Name',
  dbName: 'name'
},{
  uiName: 'Herb Temp Min Min',
  dbName: 'herbTempMinMin'
},{
  uiName: 'Herb Temp Min Max',
  dbName: 'herbTempMinMax'
},{
  uiName: 'Herb VPD Min',
  dbName: 'herbVpdMin'
},{
  uiName: 'Herb VPD Max',
  dbName: 'herbVpdMax'
},{
  uiName: 'Herb VPD Avg Flag',
  dbName: 'herbVpdAvgFlg'
},{
  uiName: 'Herb Day Length Min',
  dbName: 'herbDayLengthMin'
},{
  uiName: 'Herb Day Length Max',
  dbName: 'herbDayLengthMax'
},{
  uiName: 'Herb Days Avg',
  dbName: 'herbDaysAvg'
},{
  uiName: 'Herb Max GSI',
  dbName: 'herbMaxGsi'
},{
  uiName: 'Herb Greenup',
  dbName: 'herbGreenup'
},{
  uiName: 'Herb Min',
  dbName: 'herbMin'
},{
  uiName: 'Herb Max',
  dbName: 'herbMax'
},{
  uiName: 'Herb Precip Total Min',
  dbName: 'herbPrecipTotalMin'
},{
  uiName: 'Herb Precip Total Min',
  dbName: 'herbPrecipTotalMax'
},{
  uiName: 'Herb Total Precip Days',
  dbName: 'herbTotalPrecipDays'
},{
  uiName: 'Herb Use Precip Flag',
  dbName: 'herbUsePrecipFlg'
},
{
  uiName: 'Woody Temp Min Min',
  dbName: 'woodyTempMinMin'
},{
  uiName: 'Woody Temp Min Max',
  dbName: 'woodyTempMinMax'
},{
  uiName: 'Woody VPD Min',
  dbName: 'woodyVpdMin'
},{
  uiName: 'Woody VPD Max',
  dbName: 'woodyVpdMax'
},{
  uiName: 'Woody VPD Avg Flag',
  dbName: 'woodyVpdAvgFlg'
},{
  uiName: 'Woody Day Length Min',
  dbName: 'woodyDayLengthMin'
},{
  uiName: 'Woody Day Length Max',
  dbName: 'woodyDayLengthMax'
},{
  uiName: 'Woody Days Avg',
  dbName: 'woodyDaysAvg'
},{
  uiName: 'Woody Max GSI',
  dbName: 'woodyMaxGsi'
},{
  uiName: 'Woody Greenup',
  dbName: 'woodyGreenup'
},{
  uiName: 'Woody Min',
  dbName: 'woodyMin'
},{
  uiName: 'Woody Max',
  dbName: 'woodyMax'
},{
  uiName: 'Woody Precip Total Min',
  dbName: 'woodyPrecipTotalMin'
},{
  uiName: 'Woody Precip Total Min',
  dbName: 'woodyPrecipTotalMax'
},{
  uiName: 'Woody Total Precip Days',
  dbName: 'woodyTotalPrecipDays'
},{
  uiName: 'Woody Use Precip Flag',
  dbName: 'woodyUsePrecipFlg'
},
{
  uiName: 'Woody Calibration',
  dbName: 'woodyCalibration'
},
{
  uiName: 'Herb Calibration',
  dbName: 'herbCalibration'
},
];

export const catalogEntityTypeForAudit =[{
  uiName: 'FuelModel',
  dbName: 'FIRE_DANGER_MODEL_CATALOG',
  catalogAuditFields: fuelCatalogAuditFields
},{
  uiName: 'LiveFuel',
  dbName: 'LIVE_FUEL_CATALOG',
  catalogAuditFields: liveCatalogAuditFields

},{
  uiName: 'Drought',
  dbName: 'DROUGHT_CATALOG',
  catalogAuditFields: droughtCatalogAuditFields
},{
  uiName: 'Dead',
  dbName: 'DEAD_FUEL_CATALOG',
  catalogAuditFields: deadCatalogAuditFields
}];

export const seasonalTrendList = [{
  where: `has_historic_data=1`,
  label: 'Has Historic Data'
},{
  where: `has_historic_data=0`,
  label: 'Does Not Have Historic Data'
}];

export const networkList = [{
  where: `network ='RAWS'`,
  label: 'RAWS'
},{
  where: `network ='ASOS'`,
  label: 'ASOS'
},{
  where: `network ='Mesonet'`,
  label: 'Mesonet'
}];

/*https://en.wikipedia.org/wiki/List_of_tz_database_time_zones all time zones taken from this site - US terroritories only*/
const hawaii =  {
  code: moment().tz("US/Hawaii").format('z'), 
  offset:Number(moment().tz("US/Hawaii").utcOffset()/60),
  id: ['US/Hawaii','America/Adak','America/Atka','Pacific/Honolulu', 'US/Aleutian']

};
const samoa =  {
  code: moment().tz("Pacific/Samoa").format('z'), 
  id: ['Pacific/Samoa','US/Samoa', 'Pacific/Pago_Pago', 'Pacific/Midway'], 
  offset:Number(moment().tz("Pacific/Samoa").utcOffset()/60), 
};
const guam=  {
  code: moment().tz("Pacific/Guam").format('z'), 
  id: ['Pacific/Guam', 'Pacific/Saipan'],
  offset:Number(moment().tz("Pacific/Guam").utcOffset()/60),
};
export const DST_TZ: TimeZones[]= [
  
  {code: 'UTC', id: ['UTC', 'GMT'], offset:0},
  {code: 'ADT', id: ['America/Halifax', 'America/Virgin','America/St_Thomas', 'America/Puerto_Rico'], offset:-3},
  {
    code: 'EDT', 
    id: ['America/New_York', 'America/Detroit', 'America/Fort_Wayne', 'America/Indiana/Indianapolis', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indianapolis', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Louisville', 'US/East-Indiana', 'US/Eastern', 'US/Michigan'], offset:-4, 
  },  
  {
    code: 'CDT', 
    id: ['America/Chicago','US/Central','US/Indiana-Starke', 'America/Indiana/Knox','America/Indiana/Tell_City','	America/Knox_IN','America/Menominee','America/North_Dakota/Beulah','	America/North_Dakota/Center','America/North_Dakota/New_Salem','America/Guatemala', 'Pacific/Easter', 'America/Mexico_City', 'America/Regina'], 
    offset:-5
  },
  {code: 'MDT', id: ['America/Denver','US/Mountain','Navajo','America/Shiprock','America/Boise'], offset:-6},
  {code: 'PDT', id: ['America/Los_Angeles','US/Pacific','US/Arizona', 'America/Phoenix'], offset:-7},
  {
    code: 'AKDT', offset:-8, 
    id: ['US/Alaska','America/Anchorage','America/Metlakatla','America/Nome','America/Juneau', 'America/Sitka', 'America/Yakutat']
  },
  hawaii, samoa, guam
];

export const LST_TZ: TimeZones[]=[
  {code: 'UTC', id: ['UTC', 'GMT'], offset:0},
  {code: 'AST', id: ['America/Halifax','America/Virgin','America/St_Thomas', 'America/Puerto_Rico'], offset:-4},
  {
    code: 'EST', 
    id:['America/New_York','America/Detroit', 'America/Fort_Wayne', 'America/Indiana/Indianapolis', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indianapolis', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Louisville', 'US/East-Indiana', 'US/Eastern', 'US/Michigan'],
    offset:-5
  },
  {
    code: 'CST', 
    id: ['America/Chicago','US/Central','US/Indiana-Starke', 'America/Indiana/Knox','America/Indiana/Tell_City','	America/Knox_IN','America/Menominee','America/North_Dakota/Beulah','	America/North_Dakota/Center','America/North_Dakota/New_Salem','America/Guatemala', 'Pacific/Easter', 'America/Mexico_City', 'America/Regina'], 
    offset:-6
  },
  {code: 'MST', id: ['America/Denver','US/Mountain','Navajo','America/Shiprock','America/Boise','US/Arizona', 'America/Phoenix'], offset:-7},
  {code: 'PST', id: ['America/Los_Angeles','US/Pacific'], offset:-8},
  {
    code: 'AKST', offset:-9, 
    id: ['US/Alaska','America/Anchorage','America/Metlakatla','America/Nome','America/Juneau', 'America/Sitka', 'America/Yakutat']
  },
  hawaii, samoa, guam
]

export const chartTableList = [
  { value: "Hourly_Temp_RH", label: "Hourly Temperature & Relative Humidity"},
  { value: "Hourly_Precipitation", label: "Hourly Precipitation",
    yAxis: 'Precipitation (IN)', dataLabel: 'Precipitation', dataKeyO: 'obs', dataKeyF: 'forecast'
  },
  { value: "Hourly_Wind", label: "Hourly Wind"},
  { value: "Hourly_Solar_Radiation", label: "Hourly Solar Radiation",
    yAxis: 'Solar Radiation', dataLabel: 'Solar Radiation', dataKeyO: 'obs', dataKeyF: 'forecast'
  },
  { value: "vapor_press_def", label: "Hourly Vapor Pressure Deficit", 
    yAxis: 'VPD (Pa)', dataLabel: 'VPD', dataKeyO: 'obs', dataKeyF: 'forecast',color:'green'
  },
  { value: "Hourly_Snow_Flag", label: "Hourly Snow Flag",
    yAxis: 'Snow Flag', dataLabel: 'Snow Flag', dataKeyO: 'obs', dataKeyF: 'forecast'
  },
];

export const fieldsForLiveCatalog:LiveCatalog[] = [
  {
    name: 'liveCatalogName',
    type: 'string',
    id: 'createUpdateliveCatalogName',
    placeHolder: 'Enter Live Catalog Name',
    label: 'Live Fuel Catalog Name',
  },
  {
    name: 'herb_temp_min_max',
    type: 'string',
    id: 'createUpdateherb_temp_min_max',
    placeHolder: 'Enter Herbaceous Temp Min Max',
    min: -20,
    max: 20,
    numberType: 'INT',
    label: 'Herbaceous Temp Min Max',
  },
  {
    name: 'herb_temp_min_min',
    type: 'string',
    id: 'createUpdateherb_temp_min_min',
    placeHolder: 'Enter Herbaceous Temp Min Min',
    min: -20,
    max: 20,
    numberType: 'INT',
    label: 'Herbaceous Temp Min Min',
  },
  {
    name: 'herb_vpd_min',
    type: 'string',
    id: 'createUpdateherb_vpd_min',
    placeHolder: 'Enter Herbaceous VPD Min',
    min: 0,
    max: 1000,
    numberType: 'INT',
    label: 'Herbaceous VPD Min',
  },
  {
    name: 'herb_vpd_max',
    type: 'string',
    id: 'createUpdateherb_vpd_max',
    placeHolder: 'Enter Herbaceous VPD Max',
    min: 0,
    max: 1000,
    numberType: 'INT',
    label: 'Herbaceous VPD Max',
  },
  {
    name: 'herb_day_length_min',
    type: 'string',
    id: 'createUpdateherb_day_length_min',
    placeHolder: 'Enter Herbaceous Day Length Min',
    min: 0,
    max: 86400,
    numberType: 'INT',
    label: 'Herbaceous Day Length Min',

  },
  {
    name: 'herb_day_length_max',
    type: 'string',
    id: 'createUpdateherb_day_length_max',
    placeHolder: 'Enter Herbaceous Day Length Max',
    min: 0,
    max: 86400,
    numberType: 'INT',
    label: 'Herbaceous Day Length Max',
  },
  {
    name: 'herb_vpd_avg_flg',
    type: 'string',
    id: 'createUpdateherb_vpd_avg_flg',
    placeHolder: 'Enter Herbaceous VPD Avg Flag',
    label: 'Herbaceous VPD Avg Flag',
    disable: true
  },
  {
    name: 'herb_days_avg',
    type: 'string',
    id: 'createUpdateherb_days_avg',
    placeHolder: 'Enter Herbaceous Days Avg',
    label: 'Herbaceous Days Avg',
    min: 0,
    max: 100,
    numberType: 'INT',
  },
  {
    name: 'herb_max_gsi',
    type: 'string',
    id: 'createUpdateherb_max_gsi',
    placeHolder: 'Enter Herbaceous Max GSI',
    label: 'Herbaceous Max GSI',
    min: 0.00,
    max: 1.00,
    numberType: 'DEC',
  },
  {
    name: 'herb_greenup',
    type: 'string',
    id: 'createUpdateherb_greenup',
    placeHolder: 'Enter Herbaceous Greenup Threshold',
    label: 'Herbaceous Greenup Threshold',
    min: 0.11,
    max: 0.99,
    numberType: 'DEC',
  },
  {
    name: 'herb_max',
    type: 'number',
    id: 'createUpdateherb_max',
    placeHolder: 'Enter Herbaceous FM Max',
    label: 'Herbaceous FM Max',
    min: 0,
    max: 500,
    numberType: 'DEC',
  },
  {
    name: 'herb_min',
    type: 'number',
    id: 'createUpdateherb_min',
    placeHolder: 'Enter Herbaceous FM Min',
    label: 'Herbaceous FM Min',
    min: 0,
    max: 500,
    numberType: 'DEC',
  },
  {
    name: 'herb_precip_total_min',
    type: 'string',
    id: 'createUpdateherb_precip_total_min',
    placeHolder: 'Enter Herbaceous Running Precip Total Min',
    label: 'Herbaceous Running Precip Total Min',
    min: 0,
    max: 50,
    numberType: 'DEC',
  },
  {
    name: 'herb_precip_total_max',
    type: 'string',
    id: 'createUpdateherb_precip_total_max',
    placeHolder: 'Enter Herbaceous Running Precip Total Max',
    label: 'Herbaceous Running Precip Total Max',
    min: 0,
    max: 50,
    numberType: 'DEC',
  },
  {
    name: 'herb_total_precip_days',
    type: 'string',
    id: 'createUpdateherb_total_precip_days',
    placeHolder: 'Enter Herbaceous Running Total Precip Days',
    label: 'Herbaceous Running Total Precip Days',
    min: 0,
    max: 120,
    numberType: 'INT',
  },
  {
    name: 'herb_use_precip_flg',
    type: 'string',
    id: 'createUpdateherb_use_precip_flg',
    placeHolder: 'Enter Herbaceous Use Precip Flag',
    label: 'Herbaceous Use Precip Flag',
  },
  {
    name: 'herb_calibration',
    type: 'string',
    id: 'createUpdateherb_calibration',
    placeHolder: 'Enter Herbaceous Calibration',
    label: 'Herbaceous Calibration',
  },



  {
    name: 'woody_temp_min_max',
    type: 'string',
    id: 'createUpdatewoody_temp_min_max',
    placeHolder: 'Enter Woody Temp Min Max',
    min: -20,
    max: 20,
    numberType: 'INT',
    label: 'Woody Temp Min Max',
  },
  {
    name: 'woody_temp_min_min',
    type: 'string',
    id: 'createUpdatewoody_temp_min_min',
    placeHolder: 'Enter Woody Temp Min Min',
    min: -20,
    max: 20,
    numberType: 'INT',
    label: 'Woody Temp Min Min',
  },
  {
    name: 'woody_vpd_min',
    type: 'string',
    id: 'createUpdatewoody_vpd_min',
    placeHolder: 'Enter Woody VPD Min',
    min: 0,
    max: 10000,
    numberType: 'INT',
    label: 'Woody VPD Min',
  },
  {
    name: 'woody_vpd_max',
    type: 'string',
    id: 'createUpdatewoody_vpd_max',
    placeHolder: 'Enter Woody VPD Max',
    min: 0,
    max: 10000,
    numberType: 'INT',
    label: 'Woody VPD Max',
  },
  {
    name: 'woody_day_length_min',
    type: 'string',
    id: 'createUpdatewoody_day_length_min',
    placeHolder: 'Enter Woody Day Length Min',
    min: 0,
    max: 86400,
    numberType: 'INT',
    label: 'Woody Day Length Min',

  },
  {
    name: 'woody_day_length_max',
    type: 'string',
    id: 'createUpdatewoody_day_length_max',
    placeHolder: 'Enter Woody Day Length Max',
    min: 0,
    max: 86400,
    numberType: 'INT',
    label: 'Woody Day Length Max',
  },
  {
    name: 'woody_vpd_avg_flg',
    type: 'string',
    id: 'createUpdatewoody_vpd_avg_flg',
    placeHolder: 'Enter Woody VPD Avg Flag',
    label: 'Woody VPD Avg Flag',
    disable: true
  },
  {
    name: 'woody_days_avg',
    type: 'string',
    id: 'createUpdatewoody_days_avg',
    placeHolder: 'Enter Woody Days Avg',
    label: 'Woody Days Avg',
    min: 0,
    max: 100,
    numberType: 'INT',
  },
  {
    name: 'woody_max_gsi',
    type: 'string',
    id: 'createUpdatewoody_max_gsi',
    placeHolder: 'Enter Woody Max GSI',
    label: 'Woody Max GSI',
    min: 0,
    max: 1,
    numberType: 'DEC',
  },
  {
    name: 'woody_greenup',
    type: 'string',
    id: 'createUpdatewoody_greenup',
    placeHolder: 'Enter Woody Greenup Threshold',
    label: 'Woody Greenup Threshold',
    min: 0.11,
    max: 0.99,
    numberType: 'DEC',
  },
  {
    name: 'woody_max',
    type: 'number',
    id: 'createUpdatewoody_max',
    placeHolder: 'Enter Woody FM Max',
    label: 'Woody FM Max',
    min: 0,
    max: 500,
    numberType: 'DEC',
  },
  {
    name: 'woody_min',
    type: 'number',
    id: 'createUpdatewoody_min',
    placeHolder: 'Enter Woody FM Min',
    label: 'Woody FM Min',
    min: 0,
    max: 500,
    numberType: 'DEC',
  },
  {
    name: 'woody_precip_total_min',
    type: 'string',
    id: 'createUpdatewoody_precip_total_min',
    placeHolder: 'Enter Woody Running Precip Total Min',
    label: 'Woody Running Precip Total Min',
    min: 0,
    max: 50,
    numberType: 'DEC',
  },
  {
    name: 'woody_precip_total_max',
    type: 'string',
    id: 'createUpdatewoody_precip_total_max',
    placeHolder: 'Enter Woody Running Precip Total Max',
    label: 'Woody Running Precip Total Max',
    min: 0,
    max: 50,
    numberType: 'DEC',
  },
  {
    name: 'woody_total_precip_days',
    type: 'string',
    id: 'createUpdatewoody_total_precip_days',
    placeHolder: 'Enter Woody Running Total Precip Days',
    label: 'Woody Running Total Precip Days',
    min: 0,
    max: 120,
    numberType: 'INT',
  },
  {
    name: 'woody_use_precip_flg',
    type: 'string',
    id: 'createUpdatewoody_use_precip_flg',
    placeHolder: 'Enter Woody Use Precip Flag',
    label: 'Woody Use Precip Flag',
  },
  {
    name: 'woody_calibration',
    type: 'string',
    id: 'createUpdatewoody_calibration',
    placeHolder: 'Enter Woody Calibration',
    label: 'Woody Calibration',
  },
]

export const additionalCharts:any[] = [
  {
    id: 'one_hr_tl_fuel_moisture',
    daily: '_min',
    dailyPerc: '_min',
    label: '1hr',
    percLine1: '3th',
    percLine2: '10th',
    labelPercLine1: '3rd',
    labelPercLine2: '10th',
    yAxisLabel: "1hr FM - Daily Min",
    title: "1 Hr Fuel Moisture - Daily Min",
    maxColor: 'blue',
    avgColor: 'green',
    minColor: '#be0000',
    fourPercentile: false,

  },
  {
    id: 'ten_hr_tl_fuel_moisture',
    daily: '_min',
    dailyPerc: '_min',
    title: "10 Hr Fuel Moisture - Daily Min",
    yAxisLabel: "10hr FM - Daily Min",
    percLine1: '3th',
    percLine2: '10th',
    labelPercLine1: '3rd',
    labelPercLine2: '10th',
    label: '10hr',
    maxColor: 'blue',
    avgColor: 'green',
    minColor: '#be0000',
    fourPercentile: false,
  },
  {
    id: 'hun_hr_tl_fuel_moisture',
    title: "100 Hr Fuel Moisture - Daily Min",
    yAxisLabel: "100hr FM - Daily Min",
    percLine1: '3th',
    percLine2: '10th',    
    labelPercLine1: '3rd',
    labelPercLine2: '10th',
    daily: '_min',
    dailyPerc: '_min',
    label: '100hr',
    maxColor: 'blue',
    avgColor: 'green',
    minColor: '#be0000',
    fourPercentile: false,
  },
  {
    id: 'thou_hr_tl_fuel_moisture',
    title: "1000 Hr Fuel Moisture - Daily Min",
    yAxisLabel: "1000hr FM - Daily Min",
    percLine1: '3th',
    percLine2: '10th',
    labelPercLine1: '3rd',
    labelPercLine2: '10th',
    daily: '_min',
    dailyPerc: '_min',
    label: '1000hr',
    maxColor: 'blue',
    avgColor: 'green',
    minColor: '#be0000',
    fourPercentile: false,
  },
  {
    id: 'herbaceous_lfi_fuel_moisture',
    daily: '',
    dailyPerc: '_max',
    percLine1: '',
    percLine2: '',
    labelPercLine1: '',
    labelPercLine2: '',
    title: 'Herbaceous Fuel Moisture',
    yAxisLabel: 'Herbaceous FM',
    label: 'Herbaceous',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    percLine1: '',
    percLine2: '',
    labelPercLine1: '',
    labelPercLine2: '',
    title: 'Woody Fuel Moisture',
    yAxisLabel: 'Woody FM',
    id: 'woody_lfi_fuel_moisture',
    daily: '',
    dailyPerc: '_max',
    label: 'Woody',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    percLine1: '',
    percLine2: '',    
    labelPercLine1: '',
    labelPercLine2: '',
    title: 'KBDI',
    yAxisLabel: 'KBDI',
    id: 'kbdi',
    daily: '',
    dailyPerc: '_max',
    label: 'KBDI',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    percLine1: '',
    percLine2: '',
    labelPercLine1: '',
    labelPercLine2: '',
    title: 'GSI',
    yAxisLabel: 'GSI',
    id:'gsi',
    daily: '',
    dailyPerc: '_max',
    label: 'GSI',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    percLine1: '90th',
    percLine2: '97th',
    labelPercLine1: '90th',
    labelPercLine2: '97th',
    title: 'VPD - Daily Max',
    yAxisLabel: 'VPD - Daily Max',
    id:'vapor_press_def_max',
    daily: '',
    dailyPerc: '',
    label: 'VPD Max',
    maxColor: '#be0000',
    avgColor: 'blue',
    minColor: 'green',
    fourPercentile: false,
  },
  {
    percLine1: '90th',
    percLine2: '97th',
    labelPercLine1: '90th',
    labelPercLine2: '97th',
    title: 'VPD - Daily Min',
    yAxisLabel: 'VPD - Daily Min',
    id:'vapor_press_def_min',
    daily: '',
    dailyPerc: '',
    label: 'VPD Min',
    maxColor: '#be0000',
    avgColor: 'blue',
    minColor: 'green',
    fourPercentile: false,
  },
];
export const fourMain = [
  {
    title: "Energy Release Component - Daily Max",
    yAxisLabel: "ERC - Daily Max",
    id: 'energy_release_component',
    daily: '_max',
    dailyPerc: '_max',
    percLine1: '90th',
    percLine2: '97th',
    percLine3: '50th',
    percLine4: '70th',
    percLine5: '80th',
    percLine6: '85th',
    labelPercLine1: '90th',
    labelPercLine2: '97th',
    labelPercLine3: '50th',
    labelPercLine4: '70th',
    labelPercLine5: '80th',
    labelPercLine6: '85th',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    title: "Burning Index - Daily Max",
    yAxisLabel: "BI - Daily Max",
    daily: '_max',
    dailyPerc: '_max',
    id: 'burning_index',
    percLine1: '90th',
    percLine2: '97th',
    percLine3: '50th',
    percLine4: '70th',
    percLine5: '80th',
    percLine6: '85th',
    labelPercLine1: '90th',
    labelPercLine2: '97th',
    labelPercLine3: '50th',
    labelPercLine4: '70th',
    labelPercLine5: '80th',
    labelPercLine6: '85th',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    title: "Spread Component - Daily Max",
    id: 'spread_component',
    yAxisLabel: "SC - Daily Max",    
    daily: '_max',
    dailyPerc: '_max',
    percLine1: '90th',
    percLine2: '97th',
    percLine3: '50th',
    percLine4: '70th',
    percLine5: '80th',
    percLine6: '85th',
    labelPercLine1: '90th',
    labelPercLine2: '97th',
    labelPercLine3: '50th',
    labelPercLine4: '70th',
    labelPercLine5: '80th',
    labelPercLine6: '85th',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,
  },
  {
    title: "Ignition Component - Daily Max",
    id: 'ignition_component',
    yAxisLabel: "IC - Daily Max",
    daily: '_max',
    dailyPerc: '_max',
    percLine1: '90th',
    percLine2: '97th',
    percLine3: '50th',
    percLine4: '70th',
    percLine5: '80th',
    percLine6: '85th',
    labelPercLine1: '90th',
    labelPercLine2: '97th',
    labelPercLine3: '50th',
    labelPercLine4: '70th',
    labelPercLine5: '80th',
    labelPercLine6: '85th',
    maxColor: '#be0000',
    avgColor: 'green',
    minColor: 'blue',
    fourPercentile: false,

  },
];

export const ndrsChartHourlyList = [
  { value: "1_10_FM", label: "1 hr FM & 10 hr FM", 
    yAxis: '1 hr FM & 10 hr FM (%)', dataLabel1: '1 hr FM', dataLabel2: '10 hr FM',
    dataKeyO1: 'oneHrObs', dataKeyO2: 'tenHrObs', dataKeyF1: 'oneHrF', dataKeyF2: 'tenHrF'
    ,color1: '#be0000', color2: 'blue'

  },
  { value: "100_1000_FM", label: "100 hr FM & 1000 hr FM", 
    yAxis: '100 hr FM & 1000 hr FM (%)', dataLabel1: '100 hr FM', dataLabel2: '1000 hr FM',
    dataKeyO1: 'hunHrObs', dataKeyO2: 'thouHrObs', dataKeyF1: 'hunHrF', dataKeyF2: 'thouHrF'
    ,color1: '#be0000', color2: 'blue'

  },
  { value: "kbdi", label: "KBDI", yAxis: 'KBDI', dataLabel: 'KBDI',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "herb_woody", label: "Herb FM & Woody FM",
    yAxis: 'Herb FM & Woody FM (%)', dataLabel1: 'Herb FM', dataLabel2: 'Woody FM',
    dataKeyO1: 'herbObs', dataKeyO2: 'woodyObs', dataKeyF1: 'herbF', dataKeyF2: 'woodyF'  
    ,color1: '#be0000', color2: 'blue'
  },
  { value: "gsi", label: "GSI", yAxis: 'GSI', dataLabel: 'GSI',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "ignition_component", label: "IC" , yAxis: 'IC', dataLabel: 'IC',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "spread_component", label: "SC", yAxis: 'SC', dataLabel: 'SC',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "energy_release_component", label: "ERC", yAxis: 'ERC', dataLabel: 'ERC',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "burning_index", label: "BI", yAxis: 'BI', dataLabel: 'BI',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
];

export const ndrsChartDailyList = [
  { value: "1_10_FM_min", label: "1 hr FM & 10 hr FM Min", 
    yAxis: '1 hr FM & 10 hr FM (%)', dataLabel1: 'Min 1 hr FM', dataLabel2: 'Min 10 hr FM',
    dataKeyO1: 'oneHrObs', dataKeyO2: 'tenHrObs', dataKeyF1: 'oneHrF', dataKeyF2: 'tenHrF',
    color1: '#be0000', color2: 'blue'
  },
  { value: "100_1000_FM_min", label: "100 hr FM & 1000 hr FM min", 
    yAxis: '100 hr FM & 1000 hr FM (%)', dataLabel1: 'Min 100 hr FM', dataLabel2: 'Min 1000 hr FM',
    dataKeyO1: 'hunHrObs', dataKeyO2: 'thouHrObs', dataKeyF1: 'hunHrF', dataKeyF2: 'thouHrF',
    color1: '#be0000', color2: 'blue'
  },
  { value: "kbdi", label: "KBDI", yAxis: 'KBDI', dataLabel: 'KBDI',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "herb_woody_max", label: "Herb FM & Woody FM",
    yAxis: 'Herb FM & Woody FM (%)', dataLabel1: 'Herb FM', dataLabel2: 'Woody FM',
    dataKeyO1: 'herbObs', dataKeyO2: 'woodyObs', dataKeyF1: 'herbF', dataKeyF2: 'woodyF',
    color1: '#be0000', color2: 'blue'

  },
  { value: "gsi", label: "GSI", yAxis: 'GSI', dataLabel: 'GSI',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "ignition_component_max", label: "IC Max", yAxis: 'IC', dataLabel: 'Max IC',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "spread_component_max", label: "SC Max", yAxis: 'SC', dataLabel: 'Max SC',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',
  },
  { value: "energy_release_component_max", label: "ERC Max", yAxis: 'ERC', dataLabel: 'Max ERC',
  dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',},
  { value: "burning_index_max", label: "BI Max", yAxis: 'BI', dataLabel: 'Max BI',
  dataKeyO: 'obs', dataKeyF: 'forecast', color: '#be0000',},
];

export const chartTableListDaily =[
  { value: "Max_Temp_Min_RH", label:"Max Temperature & Min RH"},
  { value: "Min_Temp_Max_RH", label:"Min Temperature & Max RH"},
  { value: "Max_Wind", label:"Daily Wind"},
  { value: "Daily_Solar_Radiation", label:"Daily Solar Radiation"},
  { value: "Daily_Precip", label:"Daily Precipitation"},
  { value: "Max_Min_VPD", label: "VPD Max & Min", yAxis: 'VPD (Pa)', dataLabel1: 'VPD Max', dataLabel2: 'VPD Min',
    dataKeyO1: 'var1Obs', dataKeyO2: 'var2Obs', dataKeyF1: 'var1F', dataKeyF2: 'var2F',
    color1: '#be0000', color2: 'blue', data1Name: 'vapor_press_def_max', data2Name: 'vapor_press_def_min'},
  { value: "Snow_Flag", label:"Snow Flag", yAxis: 'Snow Flag', dataLabel: 'Snow Flag',
    dataKeyO: 'obs', dataKeyF: 'forecast', color: '#666',},
]

export const hours=[
  {value: '00', label: '00:00'},
  {value: '01', label: '01:00'},
  {value: '02', label: '02:00'},
  {value: '03', label: '03:00'},
  {value: '04', label: '04:00'},
  {value: '05', label: '05:00'},
  {value: '06', label: '06:00'},
  {value: '07', label: '07:00'},
  {value: '08', label: '08:00'},
  {value: '09', label: '09:00'},
  {value: '10', label: '10:00'},
  {value: '11', label: '11:00'},
  {value: '12', label: '12:00'},
  {value: '13', label: '13:00'},
  {value: '14', label: '14:00'},
  {value: '15', label: '15:00'},
  {value: '16', label: '16:00'},
  {value: '17', label: '17:00'},
  {value: '18', label: '18:00'},
  {value: '19', label: '19:00'},
  {value: '20', label: '20:00'},
  {value: '21', label: '21:00'},
  {value: '22', label: '22:00'},
  {value: '23', label: '23:00'}
];

export const weatherSelectDownload = [
  {value: 'observation', label: 'Weather Observation'},
  {value: 'forecast', label: 'Weather Forecast'},
  {value: 'observationforecast', label: 'Weather Observation and Appended Forecast'}
];

export const FireDangerSelectDownload = [
  {value: 'observation', label: 'Fire Danger Observation'},
  {value: 'forecast', label: 'Fire Danger Forecast'},
  {value: 'observationforecast', label: 'Fire Danger Observation and Forecast'}
];

export const FireDangerFileFormatHourly = [
  {value: 'csv-utc', label: 'CSV (UTC)'},
  {value: 'csv-lst', label: 'CSV (LST - Local Standard Time)'},
  {value: 'zip-utc', label: 'ZIP (UTC)'},
  {value: 'zip-lst', label: 'ZIP (LST - Local Standard Time)'},
];

export const FireDangerFileFormatDaily = [
  {value: 'csv', label: 'CSV (LST - Local Standard Time)'},
  {value: 'zip', label: 'ZIP (LST - Local Standard Time)'},
];

export const weatherFileFormatHourly = [
  {value: 'csv', label: 'CSV (UTC)'},
  {value: 'fw21', label: 'FW21 (LST - Local Standard Time)'},
  {value: 'zip', label: 'ZIP (UTC)'},

];
export const weatherFileFormatDaily = [
  {value: 'csv', label: 'CSV (LST - Local Standard Time)'},
  {value: 'zip', label: 'ZIP (LST - Local Standard Time)'},
];
export const FuelModels =['All', 'V', 'W', 'X', 'Y', 'Z']
export const FuelCatalogBasedOnModels =['All','Slope Class', 'Grass Type', 'MXD Override', 'SCM', 'Drought Catalog', 'Dead Fuel Catalog', 'Live Fuel Catalog'];
export const GrassTypeOptions = ['P', 'A'];

export const DataTypeList = [
  { value: 'Weather', label:'Weather'}, 
  {label:'Field Sample', value: 'FieldSample'},
  {label:'Fire Danger', value: 'FireDanger'}
]


export const alertMessages = {
  loginError: 'There was an error processing your request to log in. Please try again, if the issue persists please contact site admin.',
  retrievingStationData: 'There was an error processing your request to retrieve station data. Please try again, if the issue persists please contact site admin.',
  retrievingSavedViews: 'There was an error processing your request to retrieve the Saved View selected. Please try again, if the issue persists please contact site admin.',
  exportDownloadData: 'There was an error processing your request to export or download data. Please try again, if the issue persists please contact site admin.',
  retrievingMapUrl: 'There was an error processing your request to upload map using url provided. Please try again, if the issue persists please contact site admin.',
  saveMapView: 'There was an error processing your request to save map view. Please try again, if the issue persists please contact site admin.',
  inapProcess: 'Looks like you are not authenticated on INAP. Please enable the browser popup and follow the INAP approval process. Once approval from INAP is complete, please try logging in again by clicking the login button.',
  snowFlagActive: 'It has been more than 3 days since data has been received from DRI. Data may be out of date.',
  requestError: 'Your session has timed out. Please refresh the browser to view the most current data.',
  greaterThan50: `50% or more of the stations may be missing current weather observations due to a data outage. Programmer's are working to resolve the issue.`,
  greaterThan05: `Less than 50% of the stations may be missing current weather observations due to a data outage. Programmer's are working to resolve the issue.`,
  sf100: 'Most recent snow flag data may not be available at this time due to a data outage. Programmers are working to resolve this issue.',
  noaa100: `Most recent forecast weather data may not be available at this time due to a data outage. Programmer's are working to resolve the issue.`,

  fieldSampleHomeData: `There was an error processing your request to retrieve fuel moisture data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  siteSampleData: `There was an error processing your request to retrieve the site fuel moisture data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  fieldSampleSave: `There was an error saving the fuel moisture data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  fieldSampleDelete: `There was an error deleting the fuel moisture data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  fieldSampleArchive:  `There was an error archiving the fuel moisture data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  saveArea: `There was an error saving the area. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  saveAreaContact:`Contact has already been added for the Area.`,
  saveGroup:`There was an error saving the Group. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  saveGroupContact:`Contact has already been added for the Group.`,
  saveSite: `There was an error saving the Site. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  retrieveContacts: `There was an error processing your request to retrieve the contact data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  saveContacts: `There was an error saving the Contact. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  saveUniqueContacts: `Contact already exists. You cannot enter a duplicate contact.`,
  getFiles: `There was an error processing your request to retrieve the file data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  saveUniqueSite: `There was an error saving the Site. The Site Name must be unique. Please try again. If the issue persists, contact the Help Desk. Refer to the Help Page.`,
  getRecalcStatuses: `There was an error processing your request to retrieve the recalc statuses. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  getAuditLog: `There was an error processing your request to retrieve audit logs. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,

  apiKey: `There was an error processing your request to create a new api key. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  report: `There was an error saving the Powerbi Report. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  reportGet: `There was an error processing your request to retrieve the reports. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  reportDelete: `There was an error deleting the Powerbi Report. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  latlong: 'Please verify Latitude and Longitude. A negative value may be required for the Longitude.',

  retrieveCatalog: `There was an error processing your request to retrieve catalog data. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  deadCatalogCreate: `There was an error saving the Dead Fuel Catalog. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,

  droughtCatalogCreate: `There was an error saving the Drought Catalog. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  liveCatalogCreate: `There was an error saving the Live Fuel Catalog. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  uniqueCatalogName: `There was an error saving the Catalog. Catalog name must be unique. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,

  fuelModelCatalogCreate: `There was an error saving the Fuel Catalog. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,

  fuelCatalogDelete: `There was an error deleting the fuel catalog. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,

  calcResultError: `There was an error processing your request to calculate NFDRS Output. Please try again. If the issue persists, contact the Help Desk, refer to the  <a href=${updatedRedirectUri}>Help Page</a>.`,
  calcWarning: `There was an error processing your request to get Weather and Intermediate values. This is a restricted station for NFDRS or Weather values.`
};

export const fireDangerModelList =["V", "W", "X", "Y", "Z"];

export const fieldSampleColors =[
  {
    minValue: -100,
    maxValue: 100000000,
    rgb: [255, 255, 255]
  },
  {
    minValue: -200,
    maxValue: -101,
    rgb: [120, 120, 120],
  }
];

//temperatures are ints
export const temperatureColors: Color[] =[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: '< -10',
    minValue: -470,
    maxValue: -9.999999,
    rgb: [255, 255, 255],
  },
  {
    value: '≥ -10',
    minValue: -10,
    maxValue: -0.9,
    rgb: [237, 225, 222],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 24.9999,
    rgb: [139, 0, 139]
  },
  {
    value: '≥ 25',
    minValue: 25,
    maxValue: 29.99999,
    rgb: [145, 44, 238]
  },
  {
    value: '≥ 30',
    minValue: 30,
    maxValue: 34.9999,
    rgb:[137, 104, 205]
  },
  {
    value: '≥ 35',
    minValue: 35,
    maxValue: 39.9999,
    rgb:[0, 238, 238]
  },
  {
    value: '≥ 40',
    minValue: 40,
    maxValue: 44.99999,
    rgb:[0, 178, 238]
  },
  {
    value: '≥ 45',
    minValue: 45,
    maxValue: 49.9999,
    rgb: [16, 78, 139]
  },
  {
    value: '≥ 50',
    minValue: 50,
    maxValue: 54.99999,
    rgb:[0, 102, 0],
  },
  {
    value: '≥ 55',
    minValue: 55,
    maxValue: 59.99999,
    rgb: [0, 205, 0]
  },
  {
    value: '≥ 60',
    minValue: 60,
    maxValue: 64.99999,
    rgb:[127, 255, 0],
  },
  {
    value: '≥ 65',
    minValue: 65,
    maxValue: 69.99999,
    rgb:[238, 238, 0]
  },
  {
    value: '≥ 70',
    minValue: 70,
    maxValue: 74.99999,
    rgb: [255, 132, 60]
  },
  {
    value: '≥ 75',
    minValue: 75,
    maxValue: 79.99999,
    rgb: [205, 133, 0],    
  },
  {
    value: '≥ 80',
    minValue: 80,
    maxValue:84.99999,
    rgb: [255, 174, 185],
  },
  {
    value: '≥ 85',
    minValue: 85,
    maxValue: 89.99999,
    rgb: [255, 106, 106],
  },
  {
    value: '≥ 90',
    minValue: 90,
    maxValue: 94.99999,
    rgb:[205, 0, 0],
  },
  {
    value: '≥ 95',
    minValue: 95,
    maxValue: 99.99999,
    rgb: [255, 0, 0],
  },
  {
    value: '≥ 100',
    minValue: 100,
    maxValue: 104.9999,
    rgb: [112, 53, 36],
  },
  {
    value: '≥ 105',
    minValue: 105,
    maxValue: 500,
    rgb: [25, 25, 25],
  }
];

//relative_humidity are ints
export const humidityColors: Color[] =[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: '< 10',
    minValue: -1000,
    maxValue: 9,
    rgb: [120, 10, 10]
  },
  {
    value: '≥ 10',
    minValue: 10,
    maxValue: 19,
    rgb: [205, 0, 0]
  },
  {
    value: '≥ 20',
    minValue: 20,
    maxValue: 29,
    rgb: [255, 106, 106]
  },
  {
    value: '≥ 30',
    minValue: 30,
    maxValue: 39,
    rgb:[238, 238, 0]
  },
  {
    value: '≥ 40',
    minValue: 40,
    maxValue: 49,
    rgb:[127, 255, 0]
  },
  {
    value: '≥ 50',
    minValue: 50,
    maxValue: 59,
    rgb:[0, 205, 0]
  },
  {
    value: '≥ 60',
    minValue: 60,
    maxValue: 69,
    rgb: [0, 102, 0]
  },
  {
    value: '≥ 70',
    minValue: 70,
    maxValue: 79,
    rgb: [16, 78, 138]
  },
  {
    value: '≥ 80',
    minValue: 80,
    maxValue: 89,
    rgb: [0, 178, 238]
  },
  {
    value: '≥ 90',
    minValue: 90,
    maxValue: 99,
    rgb:[0, 238, 238]
  },
  {
    value: '≥ 100',
    minValue: 100,
    maxValue: 1000,
    rgb:[25, 25, 25]
  }
];

//hourly_precip are numeric
export const precip: Color[] =[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: '< 0.01',
    minValue: 0,
    maxValue: 0.009999999999999,
    rgb: [255, 255, 255]
  },
  {
    value: '≥ 0.01',
    minValue: 0.01,
    maxValue: 0.0499999999999999,
    rgb:[237, 225, 222]
  },
  {
    value: '≥ 0.05',
    minValue: 0.05,
    maxValue: 0.09999999999999,
    rgb: [90, 40, 112]
  },
  {
    value: '≥ 0.1',
    minValue: 0.1,
    maxValue: 0.149999999999999,
    rgb: [139, 0, 139]
  },
  {
    value: '≥ 0.15',
    minValue: 0.15,
    maxValue: 0.199999999999999,
    rgb:[137, 104, 205]
  },
  {
    value: '≥ 0.2',
    minValue: 0.2,
    maxValue: 0.249999999999999,
    rgb:[0, 238, 238]
  },
  {
    value: '≥ 0.25',
    minValue: 0.25,
    maxValue: 0.299999999999999,
    rgb:[0, 178, 238]
  },
  {
    value: '≥ 0.3',
    minValue: 0.3,
    maxValue: 0.349999999999999,
    rgb:[16, 78, 139]
  },
  {
    value: '≥ 0.35',
    minValue: 0.35,
    maxValue: 0.39999999999999,
    rgb:[40, 55, 112 ]
  },
  {
    value: '≥ 0.4',
    minValue: 0.4,
    maxValue: 0.449999999999999,
    rgb: [40, 105, 112],
  },
  {
    value: '≥ 0.45',
    minValue: 0.45,
    maxValue: 0.49999999999999,
    rgb: [0, 102, 0]
  },
  {
    value: '≥ 0.5',
    minValue: 0.5,
    maxValue: 0.549999999999999,
    rgb: [0, 205, 0] 
  },
  {
    value: '≥ 0.55',
    minValue: 0.55,
    maxValue:0.59999999999999,
    rgb:[127, 255, 0]
  },
  {
    value: '≥ 0.6',
    minValue: 0.6,
    maxValue: 0.649999999999999,
    rgb:[238, 238, 0]
  },
  {
    value: '≥ 0.65',
    minValue: 0.65,
    maxValue: 0.69999999999999,
    rgb:[255, 132, 60]
  },
  {
    value: '≥ 0.7',
    minValue: 0.7,
    maxValue: 0.749999999999999,
    rgb: [205, 133, 0]
  },
  {
    value: '≥ 0.75',
    minValue: 0.75,
    maxValue: 0.799999999999999,
    rgb: [191, 103, 51]
  },
  {
    value: '≥ 0.8',
    minValue: 0.8,
    maxValue: 0.849999999999999,
    rgb:[255, 72, 173]
  },
  {
    value: '≥ 0.85',
    minValue: 0.85,
    maxValue: 0.89999999999999,
    rgb: [255, 174, 185]
  },
  {
    value: '≥ 0.9',
    minValue: 0.9,
    maxValue: 0.949999999999999,
    rgb: [255, 106, 106]
    
  },
  {
    value: '≥ 0.95',
    minValue: 0.95,
    maxValue: 0.9999999999,
    rgb: [185, 55, 76]
  },
  {
    value: '≥ 1.0',
    minValue: 1,
    maxValue: 1.49999999999,
    rgb:[205, 0, 0]
  },
  {
    value: '≥ 1.5',
    minValue: 1.5,
    maxValue: 1.9999999999,
    rgb: [255, 0, 0]
  },
  {
    value: '≥ 2.0',
    minValue: 2,
    maxValue: 2.49999999999,
    rgb: [112, 53, 36]
  },
  {
    value: '≥ 2.5',
    minValue: 2.5,
    maxValue: 2.9999999999,
    rgb: [25, 25, 25]
  },

  {
    value: '≥ 3.0',
    minValue: 3,
    maxValue: 100,
    rgb: [120, 120, 120]
  },
];
//wind_speed and peak_gust_speed are ints
export const windGustColors: Color[] =[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: '< 5',
    minValue: 0,
    maxValue: 4,
    rgb: [237, 225, 222]
  },
  {
    value: '≥ 5',
    minValue: 5,
    maxValue: 7.4,
    rgb: [139, 0, 139]
  },
  {
    value: '≥ 7.5',
    minValue: 7.5,
    maxValue: 9,
    rgb: [145, 44, 238]
  },
  {
    value: '≥ 10',
    minValue: 10,
    maxValue: 12.4,
    rgb:[137, 104, 205]
  },
  {
    value: '≥ 12.5',
    minValue: 12.5,
    maxValue: 14,
    rgb:[0, 238, 238]
  },
  {
    value: '≥ 15',
    minValue: 15,
    maxValue: 17.4,
    rgb:[0, 178, 238]
  },
  {
    value: '≥ 17.5',
    minValue: 17.5,
    maxValue: 19,
    rgb: [16, 78, 139]
  },
  {
    value: '≥ 20',
    minValue: 20,
    maxValue: 22.4,
    rgb: [0, 102, 0]
  },
  {
    value: '≥ 22.5',
    minValue: 22.5,
    maxValue: 24,
    rgb: [0, 205, 0]
  },
  {
    value: '≥ 25',
    minValue: 25,
    maxValue: 27.4,
    rgb:[127, 255, 0]
  },
  {
    value: '≥ 27.5',
    minValue: 27.5,
    maxValue: 29,
    rgb:[238, 238, 0]
  },
  {
    value: '≥ 30',
    minValue: 30,
    maxValue: 32.4,
    rgb: [205, 133, 0]
  },
  {
    value: '≥ 32.5',
    minValue: 32.5,
    maxValue: 34,
    rgb: [255, 174, 185]
  },
  {
    value: '≥ 35',
    minValue: 35,
    maxValue: 37.4,
    rgb: [255, 106, 106]
  },
  {
    value: '≥ 37.5',
    minValue: 37.5,
    maxValue: 39,
    rgb:[205, 0, 0]
  },
  {
    value: '≥ 40',
    minValue: 40,
    maxValue: 42.4,
    rgb: [255, 0, 0]
  },
  {
    value: '≥ 42.5',
    minValue: 42.5,
    maxValue: 44,
    rgb: [112, 53, 36]
  },
  {
    value: '≥ 45',
    minValue: 45,
    maxValue: 47.4,
    rgb: [25, 25, 25]
  },
  {
    value: '≥ 47.5',
    minValue: 47.5,
    maxValue: 143,
    rgb: [120, 120, 120]
  },
  {
    value: '≥ 144',
    minValue: 144,
    maxValue: 1000,
    rgb: [255, 255, 255]
  },
];
//sol_rad are numeric
export const solarRadiationColors: Color[] =[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 99.9999999999999,
    rgb: [5, 48, 97]
  },
  {
    value: '≥ 100',
    minValue: 100,
    maxValue: 199.9999999999999,
    rgb: [46, 64, 160]
  },
  {
    value: '≥ 200',
    minValue: 200,
    maxValue: 299.9999999999999,
    rgb: [82, 91, 190]
  },
  {
    value: '≥ 300',
    minValue:300,
    maxValue: 399.9999999999999,
    rgb:[113, 122, 209]
  },
  {
    value: '≥ 400',
    minValue: 400,
    maxValue: 499.9999999999999,
    rgb:[142, 155, 220]
  },
  {
    value: '≥ 500',
    minValue: 500,
    maxValue:599.9999999999999,
    rgb:[170, 190, 227]
  },
  {
    value: '≥ 600',
    minValue: 600,
    maxValue: 699.9999999999999,
    rgb: [201, 225, 228]
  },
  {
    value: '≥ 700',
    minValue: 700,
    maxValue: 799.9999999999999,
    rgb: [255, 255, 224]
  },
  {
    value: '≥ 800',
    minValue: 800,
    maxValue: 899.9999999999999,
    rgb: [255, 211, 164]
  },
  {
    value: '≥ 900',
    minValue: 900,
    maxValue: 999.9999999999999,
    rgb:[254, 165, 108]
  },
  {
    value: '≥ 1000',
    minValue: 1000,
    maxValue: 1099,
    rgb:[237, 121, 65]
  },
  {
    value: '≥ 1100',
    minValue: 1100,
    maxValue: 1199,
    rgb: [211, 80, 32]
  },
  {
    value: '≥ 1200',
    minValue: 1200,
    maxValue: 1299,
    rgb: [176, 43, 13]
  },
  {
    value: '≥ 1300',
    minValue: 1300,
    maxValue: 1399,
    rgb: [134, 12, 6]
  },
  {
    value: '≥ 1400',
    minValue: 1400,
    maxValue: 10000,
    rgb:[87, 0, 0]
  },
];
//snow_flag are characters
export const snowFlagColors: Color[]=[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: 'Y',
    rgb: [41, 62, 155],
    minValue: 0,
    maxValue: 0.9,
  },
  {
    value: 'N',
    rgb: [192, 68, 0],
    minValue: 1,
    maxValue: 2,
  },
];

export const noColors: Color[]=[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '',
    rgb: [255,236,139],
    minValue: -1000,
    maxValue: 10000000,
  },
];

//vapor_press_def are numeric
export const vpdColors: Color[] =[
  {
    value: -2000,
    minValue: -2000,
    maxValue: -1999,
    rgb: [120, 120, 120],
  },
  {
    value: '< 200',
    minValue: -1000,
    maxValue: 199,
    rgb: [0, 27, 25]
  },
  {
    value: '≥ 200',
    minValue: 200,
    maxValue: 779,
    rgb: [3, 70, 32]
  },
  {
    value: '≥ 780',
    minValue: 780,
    maxValue: 1359,
    rgb: [1, 102, 94]
  },
  {
    value: '≥ 1360',
    minValue: 1360,
    maxValue: 1939,
    rgb: [53, 151, 143]
  },
  {
    value: '≥ 1940',
    minValue: 1940,
    maxValue: 2519,
    rgb:[128, 205, 193]
  },
  {
    value: '≥ 2520',
    minValue: 2520,
    maxValue: 3099,
    rgb:[199, 234, 229]
  },
  {
    value: '≥ 3100',
    minValue: 3100,
    maxValue: 3679,
    rgb:[245, 239, 224]
  },
  {
    value: '≥ 3680',
    minValue: 3680,
    maxValue: 4259,
    rgb: [246, 232, 195]
  },
  {
    value: '≥ 4260',
    minValue: 4260,
    maxValue: 4839,
    rgb: [223, 194, 125]
  },
  {
    value: '≥ 4840',
    minValue: 4840,
    maxValue: 5419,
    rgb: [191, 129, 45]
  },
  {
    value: '≥ 5420',
    minValue: 5420,
    maxValue: 5999,
    rgb:[254, 165, 108]
  },
  {
    value: '≥ 6000',
    minValue: 6000,
    maxValue: 10000000,
    rgb:[84, 48, 5]
  }
];

export const oneDeadFuelColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 1.99999,
    rgb: [87, 0, 0]
  },
  {
    value: '≥ 2',
    minValue: 2,
    maxValue: 2.99999,
    rgb: [108, 0, 0]
  },
  {
    value: '≥ 3',
    minValue: 3,
    maxValue: 3.99999,
    rgb: [130, 0, 0]
  },
  {
    value: '≥ 4',
    minValue: 4,
    maxValue: 4.99999,
    rgb:[160, 0, 0]
  },
  {
    value: '≥ 5',
    minValue: 5,
    maxValue: 5.99999,
    rgb:[190, 20, 0]
  },
  {
    value: '≥ 6',
    minValue: 6,
    maxValue: 6.99999,
    rgb:[215, 55, 0]
  },
  {
    value: '≥ 7',
    minValue: 7,
    maxValue: 7.99999,
    rgb: [230, 92, 0]
  },
  {
    value: '≥ 8',
    minValue: 8,
    maxValue: 8.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 9',
    minValue: 9,
    maxValue: 9.99999,
    rgb: [245, 170, 0]
  },
  {
    value: '≥ 10',
    minValue: 10,
    maxValue: 10.99999,
    rgb:[250, 205, 70]
  },
  {
    value: '≥ 11',
    minValue: 11,
    maxValue: 11.99999,
    rgb:[255, 235, 140]
  },
  {
    value: '≥ 12',
    minValue: 12,
    maxValue: 13.99999,
    rgb:[255, 255, 224]
  },
  {
    value: '≥ 14',
    minValue: 14,
    maxValue: 16.99999,
    rgb: [201, 225, 228]
  },
  {
    value: '≥ 17',
    minValue: 17,
    maxValue: 24.99999,
    rgb: [170, 190, 227]
  },
  {
    value: '≥ 25',
    minValue: 25,
    maxValue: 1000000,
    rgb: [142, 155, 220]
  }
];

export const tenDeadFuelColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 3.99999,
    rgb: [87, 0, 0]
  },
  {
    value: '≥ 4',
    minValue: 4,
    maxValue: 4.99999,
    rgb: [108, 0, 0]
  },
  {
    value: '≥ 5',
    minValue: 5,
    maxValue: 5.99999,
    rgb: [130, 0, 0]
  },
  {
    value: '≥ 6',
    minValue: 6,
    maxValue: 6.99999,
    rgb:[160, 0, 0]
  },
  {
    value: '≥ 7',
    minValue: 7,
    maxValue: 7.99999,
    rgb:[190, 20, 0]
  },
  {
    value: '≥ 8',
    minValue: 8,
    maxValue: 8.99999,
    rgb:[215, 55, 0]
  },
  {
    value: '≥ 9',
    minValue: 9,
    maxValue: 9.99999,
    rgb: [230, 92, 0]
  },
  {
    value: '≥ 10',
    minValue: 10,
    maxValue: 10.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 11',
    minValue: 11,
    maxValue: 11.99999,
    rgb: [245, 170, 0]
  },
  {
    value: '≥ 12',
    minValue: 12,
    maxValue: 12.99999,
    rgb:[250, 205, 70]
  },
  {
    value: '≥ 13',
    minValue: 13,
    maxValue: 13.99999,
    rgb:[255, 235, 140]
  },
  {
    value: '≥ 14',
    minValue: 14,
    maxValue: 14.99999,
    rgb:[255, 255, 224]
  },
  {
    value: '≥ 15',
    minValue: 15,
    maxValue: 16.99999,
    rgb: [201, 225, 228]
  },
  {
    value: '≥ 17',
    minValue: 17,
    maxValue: 23.99999,
    rgb: [170, 190, 227]
  },
  {
    value: '≥ 24',
    minValue: 24,
    maxValue: 1000000,
    rgb: [142, 155, 220]
  }
];

export const hunDeadFuelColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 5.99999,
    rgb: [87, 0, 0]
  },
  {
    value: '≥ 6',
    minValue: 6,
    maxValue: 6.99999,
    rgb: [108, 0, 0]
  },
  {
    value: '≥ 7',
    minValue: 7,
    maxValue: 7.99999,
    rgb: [130, 0, 0]
  },
  {
    value: '≥ 8',
    minValue: 8,
    maxValue: 8.99999,
    rgb:[160, 0, 0]
  },
  {
    value: '≥ 9',
    minValue: 9,
    maxValue: 9.99999,
    rgb:[190, 20, 0]
  },
  {
    value: '≥ 10',
    minValue: 10,
    maxValue: 10.99999,
    rgb:[215, 55, 0]
  },
  {
    value: '≥ 11',
    minValue: 11,
    maxValue: 11.99999,
    rgb: [230, 92, 0]
  },
  {
    value: '≥ 12',
    minValue: 12,
    maxValue: 12.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 13',
    minValue: 13,
    maxValue: 13.99999,
    rgb: [245, 170, 0]
  },
  {
    value: '≥ 14',
    minValue: 14,
    maxValue: 14.99999,
    rgb:[250, 205, 70]
  },
  {
    value: '≥ 15',
    minValue: 15,
    maxValue: 15.99999,
    rgb:[255, 235, 140]
  },
  {
    value: '≥ 16',
    minValue: 16,
    maxValue: 16.99999,
    rgb:[255, 255, 224]
  },
  {
    value: '≥ 17',
    minValue: 17,
    maxValue: 17.99999,
    rgb: [201, 225, 228]
  },
  {
    value: '≥ 18',
    minValue: 18,
    maxValue: 19.99999,
    rgb: [170, 190, 227]
  },
  {
    value: '≥ 20',
    minValue: 20,
    maxValue: 1000000,
    rgb: [142, 155, 220]
  }
];

export const thouDeadFuelColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 6.99999,
    rgb: [87, 0, 0]
  },
  {
    value: '≥ 7',
    minValue: 7,
    maxValue: 7.99999,
    rgb: [108, 0, 0]
  },
  {
    value: '≥ 8',
    minValue: 8,
    maxValue: 8.99999,
    rgb: [130, 0, 0]
  },
  {
    value: '≥ 9',
    minValue: 9,
    maxValue: 9.99999,
    rgb:[160, 0, 0]
  },
  {
    value: '≥ 10',
    minValue: 10,
    maxValue: 10.99999,
    rgb:[190, 20, 0]
  },
  {
    value: '≥ 11',
    minValue: 11,
    maxValue: 11.99999,
    rgb:[215, 55, 0]
  },
  {
    value: '≥ 12',
    minValue: 12,
    maxValue: 12.99999,
    rgb: [230, 92, 0]
  },
  {
    value: '≥ 13',
    minValue: 13,
    maxValue: 13.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 14',
    minValue: 14,
    maxValue: 14.99999,
    rgb: [245, 170, 0]
  },
  {
    value: '≥ 15',
    minValue: 15,
    maxValue: 15.99999,
    rgb:[250, 205, 70]
  },
  {
    value: '≥ 16',
    minValue: 16,
    maxValue: 16.99999,
    rgb:[255, 235, 140]
  },
  {
    value: '≥ 17',
    minValue: 17,
    maxValue: 17.99999,
    rgb:[255, 255, 224]
  },
  {
    value: '≥ 18',
    minValue: 18,
    maxValue: 18.99999,
    rgb: [201, 225, 228]
  },
  {
    value: '≥ 19',
    minValue: 19,
    maxValue: 19.99999,
    rgb: [170, 190, 227]
  },
  {
    value: '≥ 20',
    minValue: 20,
    maxValue: 1000000,
    rgb: [142, 155, 220]
  }
];

export const kbdiColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 49.99999,
    rgb: [142, 155, 220]
  },
  {
    value: '≥ 50',
    minValue: 50,
    maxValue: 99.99999,
    rgb: [170, 190, 227]
  },
  {
    value: '≥ 100',
    minValue: 100,
    maxValue: 149.99999,
    rgb: [201, 225, 228]
  },
  {
    value: '≥ 150',
    minValue: 150,
    maxValue: 199.99999,
    rgb: [255, 255, 224]
  },
  {
    value: '≥ 200',
    minValue: 200,
    maxValue: 249.99999,
    rgb:[255, 235, 140]
  },
  {
    value: '≥ 250',
    minValue: 250,
    maxValue: 299.99999,
    rgb:[250, 205, 70]
  },
  {
    value: '≥ 300',
    minValue: 300,
    maxValue: 349.99999,
    rgb:[245, 170, 0]
  },
  {
    value: '≥ 350',
    minValue: 350,
    maxValue: 399.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 400',
    minValue: 400,
    maxValue: 449.99999,
    rgb: [230, 92, 0]
  },
  {
    value: '≥ 450',
    minValue: 450,
    maxValue: 499.99999,
    rgb: [215, 55, 0]
  },
  {
    value: '≥ 500',
    minValue: 500,
    maxValue: 549.99999,
    rgb:[190, 20, 0]
  },
  {
    value: '≥ 550',
    minValue: 550,
    maxValue: 599.99999,
    rgb:[160, 0, 0]
  },
  {
    value: '≥ 600',
    minValue: 600,
    maxValue: 649.99999,
    rgb:[148, 0, 0]
  },
  {
    value: '≥ 650',
    minValue: 650,
    maxValue: 699.99999,
    rgb: [130, 0, 0]
  },
  {
    value: '≥ 700',
    minValue: 700,
    maxValue: 749.99999,
    rgb: [108, 0, 0]
  },
  {
    value: '≥ 750',
    minValue: 750,
    maxValue: 1000000,
    rgb: [87, 0, 0]
  }
];

export const herbFMColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '= 30',
    minValue: 30,
    maxValue: 30.9999,
    rgb: [87, 0, 0]
  },
  {
    value: '≥ 31',
    minValue: 31,
    maxValue: 44.99999,
    rgb: [160, 0, 0]
  },
  {
    value: '≥ 45',
    minValue: 45,
    maxValue: 59.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 60',
    minValue: 60,
    maxValue: 74.99999,
    rgb: [225, 235, 140]
  },
  {
    value: '≥ 75',
    minValue: 75,
    maxValue: 89.99999,
    rgb:[220, 225, 120]
  },
  {
    value: '≥ 90',
    minValue: 90,
    maxValue: 104.99999,
    rgb:[180, 210, 100]
  },
  {
    value: '≥ 105',
    minValue: 105,
    maxValue: 119.99999,
    rgb:[130, 190, 85]
  },
  {
    value: '≥ 120',
    minValue: 120,
    maxValue: 154.99999,
    rgb: [80, 160, 70]
  },
  {
    value: '≥ 155',
    minValue: 155,
    maxValue: 189.99999,
    rgb: [40, 120, 55]
  },
  {
    value: '≥ 190',
    minValue: 190,
    maxValue: 10000000,
    rgb: [15, 75, 35]
  },
 
];

export const woodyFMColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '= 60',
    minValue: 60,
    maxValue: 60.9999,
    rgb: [87, 0, 0]
  },
  {
    value: '≥ 61',
    minValue: 61,
    maxValue: 69.99999,
    rgb: [160, 0, 0]
  },
  {
    value: '≥ 70',
    minValue: 70,
    maxValue: 79.99999,
    rgb: [240, 130, 0]
  },
  {
    value: '≥ 80',
    minValue: 80,
    maxValue: 89.99999,
    rgb: [225, 235, 140]
  },
  {
    value: '≥ 90',
    minValue: 90,
    maxValue: 99.99999,
    rgb:[220, 225, 120]
  },
  {
    value: '≥ 100',
    minValue: 100,
    maxValue: 109.99999,
    rgb:[180, 210, 100]
  },
  {
    value: '≥ 110',
    minValue: 110,
    maxValue: 119.99999,
    rgb:[130, 190, 85]
  },
  {
    value: '≥ 120',
    minValue: 120,
    maxValue: 139.99999,
    rgb: [80, 160, 70]
  },
  {
    value: '≥ 140',
    minValue: 140,
    maxValue: 159.99999,
    rgb: [40, 120, 55]
  },
  {
    value: '≥ 160',
    minValue: 160,
    maxValue: 10000000,
    rgb: [15, 75, 35]
  },
 
];


export const gsiColors: Color[] =[
  {
    value: -500000,
    minValue: -500000,
    maxValue: -499999,
    rgb: [120, 120, 120],
  },
  {
    value: '≥ 0',
    minValue: 0,
    maxValue: 0.19999,
    rgb: [160, 0, 38]
  },
  {
    value: '≥ 0.2',
    minValue: 0.2,
    maxValue: 0.299999,
    rgb: [215, 48, 39]
  },
  {
    value: '≥ 0.3',
    minValue: 0.3,
    maxValue: 0.399999,
    rgb: [253, 174, 97]
  },
  {
    value: '≥ 0.4',
    minValue: 0.4,
    maxValue: 0.499999,
    rgb: [217, 239, 139]
  },
  {
    value: '≥ 0.5',
    minValue: 0.5,
    maxValue: 0.599999,
    rgb:[166,217, 106]
  },
  {
    value: '≥ 0.6',
    minValue: 0.6,
    maxValue: 0.699999,
    rgb:[102, 189, 99]
  },
  {
    value: '≥ 0.7',
    minValue: 0.7,
    maxValue: 0.799999,
    rgb:[102, 189, 80]
  },
  {
    value: '≥ 0.8',
    minValue: 0.8,
    maxValue: 0.899999,
    rgb: [26, 152, 80]
  },
  {
    value: '≥ 0.9',
    minValue: 0.9,
    maxValue: 2,
    rgb: [0, 104, 55]
  },
 
];

export const wxhourlySelections: ElementSelect[] =[
  { label: 'Temperature', type: 'hourly', value: 'temperature', unit: '°F', legendType: 'Temperature', colors: temperatureColors, defaultChart: chartTableList[0]},
  { label: 'Relative Humidity', type: 'hourly', value:'relative_humidity',unit:'%', legendType: 'Relative Humidity', colors: humidityColors, defaultChart: chartTableList[0]},
  { label: 'Precipitation', type: 'hourly', value:'hourly_precip',unit:'in', legendType: 'Precipitation', colors: precip, defaultChart: chartTableList[1]},
  { label: 'Wind Speed', type: 'hourly',value: 'wind_speed',unit: 'mph', legendType:'Wind Speed', colors: windGustColors, defaultChart: chartTableList[2]},
  { label: 'Gust Speed', type: 'hourly',value: 'peak_gust_speed', unit: 'mph', legendType: 'Gust Speed', colors: windGustColors, defaultChart: chartTableList[2]},
  { label: 'Solar Radiation', type: 'hourly',value: 'sol_rad', unit:'W/m2', legendType: 'Solar Radiation', colors: solarRadiationColors,defaultChart: chartTableList[3]},
  { label: 'Vapor Pressure Deficit', type: 'hourly', value: 'vapor_press_def', unit: 'Pa', legendType: 'Vapor Pressure Deficit', colors: vpdColors, defaultChart: chartTableList[4] }
];

export const nfdrhourlySelections: ElementSelect[] =[
  { label: '1 Hr FM', type: 'hourly', value: 'one_hr_tl_fuel_moisture', unit: '', legendType: '1 Hr FM', colors: oneDeadFuelColors, defaultChart: ndrsChartHourlyList[0]},
  { label: '10 Hr FM', type: 'hourly', value: 'ten_hr_tl_fuel_moisture', unit: '', legendType: '10 Hr FM', colors: tenDeadFuelColors, defaultChart: ndrsChartHourlyList[0]},
  { label: '100 Hr FM', type: 'hourly', value: 'hun_hr_tl_fuel_moisture', unit: '', legendType: '100 Hr FM', colors: hunDeadFuelColors, defaultChart: ndrsChartHourlyList[1]},
  { label: '1000 Hr FM', type: 'hourly', value: 'thou_hr_tl_fuel_moisture', unit: '', legendType: '1000 Hr FM', colors: thouDeadFuelColors, defaultChart: ndrsChartHourlyList[1]},
  { label: 'IC', type: 'hourly', value: 'ignition_component', unit: '', legendType: 'IC', colors: noColors, defaultChart: ndrsChartHourlyList[5]},
  { label: 'SC', type: 'hourly', value: 'spread_component', unit: '', legendType: 'SC', colors: noColors, defaultChart: ndrsChartHourlyList[6]},
  { label: 'ERC', type: 'hourly', value: 'energy_release_component', unit: '', legendType: 'ERC', colors: noColors, defaultChart: ndrsChartHourlyList[7]},
  { label: 'BI', type: 'hourly', value: 'burning_index', unit: '', legendType: 'BI', colors: noColors, defaultChart: ndrsChartHourlyList[8]},

];

export const wxdailySelections: ElementSelect[] =[
  { label: 'Max Temperature', type: 'dailyMax', value: 'temperature_max', unit: '°F', legendType: 'Temperature', colors: temperatureColors, defaultChart: chartTableListDaily[0]},
  { label: 'Min Temperature', type: 'dailyMin', value: 'temperature_min', unit: '°F', legendType: 'Temperature', colors: temperatureColors, defaultChart: chartTableListDaily[1]},
  { label: 'Max Relative Humidity', type: 'dailyMax', value:'relative_humidity_max',unit:'%', legendType: 'Relative Humidity', colors: humidityColors, defaultChart: chartTableListDaily[1]},
  { label: 'Min Relative Humidity', type: 'dailyMin', value:'relative_humidity_min',unit:'%', legendType: 'Relative Humidity', colors: humidityColors, defaultChart: chartTableListDaily[0]},
  { label: 'Daily Sum Precipitation', type: 'daily', value:'daily_precipitation_total',unit:'in', legendType: 'Precipitation', colors: precip, defaultChart: chartTableListDaily[4]},
  { label: 'Max Wind Speed', type: 'dailyMax',value: 'wind_speed_max',unit: 'mph', legendType:'Wind Speed', colors: windGustColors, defaultChart: chartTableListDaily[2]},
  { label: 'Min Wind Speed', type: 'dailyMin',value: 'wind_speed_min',unit: 'mph', legendType:'Wind Speed', colors: windGustColors, defaultChart: chartTableListDaily[2]},
  { label: 'Max VPD', type: 'dailyMax',value: 'vapor_press_def_max', unit: 'Pa', legendType: 'Vapor Pressure Deficit', colors: vpdColors, defaultChart: chartTableListDaily[5]},
  { label: 'Max Gust Speed', type: 'dailyMax',value: 'peak_gust_speed_max', unit: 'mph', legendType: 'Gust Speed', colors: windGustColors, defaultChart: chartTableListDaily[2]},
  { label: 'Max Solar Radiation', type: 'dailyMax',value: 'solar_radiation_max', unit:'W/m2', legendType: 'Solar Radiation', colors: solarRadiationColors, defaultChart: chartTableListDaily[3]},
  { label: 'Snow Flag', type: 'snowflag', value: "snow_flag", legendType: 'Snow Flag', colors: snowFlagColors, defaultChart: chartTableListDaily[6]}
]
export const nfdrdailySelections: ElementSelect[] =[
  { label: '1 Hr FM Min', type: 'dailyMin', value: 'one_hr_tl_fuel_moisture_min', unit: '', legendType: '1 Hr FM Min', colors: oneDeadFuelColors, defaultChart: ndrsChartDailyList[0]},
  { label: '10 Hr FM Min', type: 'dailyMin', value: 'ten_hr_tl_fuel_moisture_min', unit: '', legendType: '10 Hr FM Min', colors: tenDeadFuelColors, defaultChart: ndrsChartDailyList[0]},
  { label: '100 Hr FM Min', type: 'dailyMin', value: 'hun_hr_tl_fuel_moisture_min', unit: '', legendType: '100 Hr FM Min', colors: hunDeadFuelColors, defaultChart: ndrsChartDailyList[1]},
  { label: '1000 Hr FM Min', type: 'dailyMin', value: 'thou_hr_tl_fuel_moisture_min', unit: '', legendType: '1000 Hr FM Min', colors: thouDeadFuelColors, defaultChart: ndrsChartDailyList[1]},
  { label: 'KBDI', type: 'dailyMax', value: 'kbdi', unit: '', legendType: 'KBDI Max', colors: kbdiColors, defaultChart: ndrsChartDailyList[2]},
  { label: 'Herb FM', type: 'dailyMax', value: 'herbaceous_lfi_fuel_moisture', unit: '', legendType: 'Herb FM Max', colors: herbFMColors, defaultChart: ndrsChartDailyList[3]},
  { label: 'Woody FM', type: 'dailyMax', value: 'woody_lfi_fuel_moisture', unit: '', legendType: 'Woody FM Max', colors: woodyFMColors, defaultChart: ndrsChartDailyList[3]},
  { label: 'GSI', type: 'dailyMax', value: 'gsi', unit: '', legendType: 'GSI Max', colors: gsiColors, defaultChart: ndrsChartDailyList[4]},
  { label: 'IC Max', type: 'dailyMax', value: 'ignition_component_max', unit: '', legendType: 'IC Max', colors: noColors, defaultChart: ndrsChartDailyList[5]},
  { label: 'SC Max', type: 'dailyMax', value: 'spread_component_max', unit: '', legendType: 'SC Max', colors: noColors, defaultChart: ndrsChartDailyList[6]},
  { label: 'ERC Max', type: 'dailyMax', value: 'energy_release_component_max', unit: '', legendType: 'ERC Max', colors: noColors, defaultChart: ndrsChartDailyList[7]},
  { label: 'BI Max', type: 'dailyMax', value: 'burning_index_max', unit: '', legendType: 'BI Max', colors: noColors, defaultChart: ndrsChartDailyList[8]},
]
export const weatherRadioButtons: RadioSelect[] = [
  {label: "Hourly", type: "hourly", dataType: "Weather", elementSelections: wxhourlySelections},
  {label: "Daily Summary", type: "daily", dataType: "Weather", elementSelections: wxdailySelections }
]
export const nfdrRadioButtons: RadioSelect[] = [
  {label: "Hourly", type: "hourly", dataType: "FireDanger", elementSelections: nfdrhourlySelections},
  {label: "Daily Max/Min", type: "daily", dataType: "FireDanger", elementSelections: nfdrdailySelections }
]

export const baseMapList = [
  { value: "USGS_Topo", label: "USGS Topo", url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer' },
  { value: "USGS_Imagery", label: "USGS Imagery", url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer' },
  { value: "Street", label: "Street", url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=EPSG:3857&layers=Layers&layerDefs=&size=&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&rotation=&datumTransformations=&layerParameterValues=&mapRangeValues=&layerRangeValues=&f=image' },
  { value: "World_Topo", label: "World Topo", url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=EPSG:3857&layers=layers&layerDefs=&size=&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&rotation=&datumTransformations=&layerParameterValues=&mapRangeValues=&layerRangeValues=&f=image' },
  { value: "World_Imagery", label:"World Imagery", url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=EPSG:3857&layers=layers&layerDefs=&size=&imageSR=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&rotation=&datumTransformations=&layerParameterValues=&mapRangeValues=&layerRangeValues=&f=image' },
  { value: "FS_Topo", label:"FS Topo", url: 'https://apps.fs.usda.gov/arcx/rest/services/EDW/EDW_FSTopo_01/MapServer/export?bbox={bbox-epsg-3857}&bboxSR=EPSG:3857&layers=layers&layerDefs=&size=&imageSR=&historicMoment=&format=png&transparent=true&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&rotation=&datumTransformations=&layerParameterValues=&mapRangeValues=&layerRangeValues=&f=image' },
];

export const boundariesList = [
  { 
    id: "Interagency Dispatch Areas", 
    label: "IDA",
    url:'https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/National_Dispatch_Current/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson'
  },
  { 
    id: "Geographic Areas (GACC)", 
    label: "GACC",
    url: 'https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services/National_GACC_Current/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson' 
  },
];

export const wxMinMaxQuery =`query WxMinMax($stationIds: String, $startDate:Date!, $endDate:Date, $zoomLevel: Int!, $hasHistoricData: TriState, $page: Int, $perPage: Int, $sortBy: WxMinMaxSortBy, $sortOrder: SortOrder, $visibilitySettings: TriState) {
  wxMinMax(
      startDate: $startDate
      endDate: $endDate
      zoomLevel: $zoomLevel
      stationIds: $stationIds
      hasHistoricData: $hasHistoricData
      page: $page
      per_page: $perPage
      sortBy: $sortBy
      sortOrder: $sortOrder
      visibilitySettings: $visibilitySettings 
  ) {
      _metadata {
        page
        per_page
        total_count
        page_count
      }
      data {
          station_id
          station_name
          summary_date
          observation_type
          temperature_min
          temperature_max
          relative_humidity_min
          relative_humidity_max
          wind_speed_min
          wind_speed_max
          peak_gust_speed_min
          peak_gust_speed_max
          peak_wind_gust_direction
          peak_wind_gust_time
          solar_radiation_max
          daily_precipitation_total  
          snow_flag
          vapor_press_def_min
          vapor_press_def_max
      }
  }
}`;


export const snowFlagActive = `query {
  snowFlagIsActive {
    data {
      snow_flag_date
      isActive
    }
  }
}`

export const weatherObsStationsQuery = `query GetWeatherObs($stationId: String! $startDate: DateTime!, $endDate:DateTime!,  $zoomLevel:Int, $hasHistoricData: TriState, $page: Int, $perPage:Int, $sortOrder: SortOrder, $sortBy: WxObsSortBy, $visibilitySettings: TriState) {
  weatherObs(
      stationIds: $stationId
      startDateTimeRange: $startDate
      endDateTimeRange: $endDate
      zoomLevel: $zoomLevel
      per_page: $perPage
      hasHistoricData: $hasHistoricData
      page: $page
      sortBy: $sortBy
      sortOrder: $sortOrder
      visibilitySettings: $visibilitySettings
    ) {
      _metadata {
        page
        per_page
        total_count
        page_count
      }
      data {
        station_id
        observation_time
        observation_time_lst
        display_hour
        display_hour_lst
        temperature
        hourly_precip
        relative_humidity
        wind_speed
        wind_direction
        peak_gust_speed
        peak_gust_dir
        sol_rad
        snow_flag
        observation_type
        vapor_press_def
      }
  }
}`;

export const weatherObsQuery = `query GetWeatherObs( $startDate: DateTime!, $endDate:DateTime!,  $zoomLevel:Int, $hasHistoricData: TriState,$sortOrder: SortOrder, $sortBy: WxObsSortBy, $visibilitySettings: TriState) {
  weatherObs(
      startDateTimeRange: $startDate
      endDateTimeRange: $endDate
      zoomLevel: $zoomLevel
      per_page: 100000
      hasHistoricData: $hasHistoricData
      sortBy: $sortBy
      sortOrder: $sortOrder
      visibilitySettings: $visibilitySettings
    ) {
      _metadata {
        page
        per_page
        total_count
        page_count
      }
      data {
        station_id
        observation_time
        observation_time_lst
        display_hour
        display_hour_lst
        temperature
        hourly_precip
        relative_humidity
        wind_speed
        wind_direction
        peak_gust_speed
        peak_gust_dir
        sol_rad
        snow_flag
        observation_type
        vapor_press_def
      }
  }
}`;


export const outageBannerAllUsers = `query{
  notification {
    	data{
        msg_token
        ingest_type
        pct_missing
        __typename
      }
  }
}`

export const stationQuery = `query GetStationMetaDataSearch($returnAll:Boolean, 
  $hasHistoricData: TriState, 
  $weatherDailyVisible: TriState, 
  $nfdrsDailyVisible: TriState, 
  $weatherHourlyVisible: TriState, 
  $nfdrsHourlyVisible: TriState, 
  $weatherDailyDownload: TriState, 
  $weatherHourlyDownload: TriState, 
  $nfdrsDailyDownload: TriState, 
  $nfdrsHourlyDownload: TriState, 
  $produceNfdrs: TriState, 
  $ingestObservation: TriState, 
  $stationId: String,
  $stationMetadataVisible: TriState
) {
  # Get Station Data
    stationMetaData(
      returnAll:$returnAll,
      hasHistoricData: $hasHistoricData,
      weatherDailyVisible: $weatherDailyVisible, 
      nfdrsDailyVisible: $nfdrsDailyVisible, 
      weatherHourlyVisible: $weatherHourlyVisible, 
      nfdrsHourlyVisible: $nfdrsHourlyVisible, 
      weatherDailyDownload: $weatherDailyDownload, 
      weatherHourlyDownload: $weatherHourlyDownload, 
      nfdrsDailyDownload: $nfdrsDailyDownload, 
      nfdrsHourlyDownload: $nfdrsHourlyDownload, 
      produceNfdrs: $produceNfdrs, 
      ingestObservation: $ingestObservation, 
      stationIds: $stationId,
      stationMetadataVisible: $stationMetadataVisible
    ){
    _metadata{
      page
      per_page
      total_count
      page_count
    }
    data{
      station_id
      fems_station_id
      wrcc_id
      state
      station_name
      latitude
      longitude
      aspect_direction
      elevation
      time_zone
      time_zone_offset
      period_record_start
      period_record_stop
      agency
      has_historic_data
      weather_daily_visible
      nfdrs_daily_visible
      weather_hourly_visible
      nfdrs_hourly_visible
      weather_daily_download
      weather_hourly_download
      nfdrs_daily_download
      nfdrs_hourly_download
      produce_nfdrs
      station_metadata_visible
      ingest_observation
      network_name
      avg_annual_precip
      fuel_models{
        slopeclass
        grasstype
      }
      vpd_min
      vpd_max
      vpd_max_percentile
      vpd_min_percentile
    }
    }
  }
`;

export const stationQueryMap = `query GetStationsMap(
$returnAll:Boolean, 
$zoomLevel:Int, 
$stationIds:String,
$weatherDailyVisible: TriState, 
$nfdrsDailyVisible: TriState, 
$weatherHourlyVisible: TriState, 
$nfdrsHourlyVisible: TriState, 
$weatherDailyDownload: TriState, 
$weatherHourlyDownload: TriState, 
$nfdrsDailyDownload: TriState, 
$nfdrsHourlyDownload: TriState, 
$produceNfdrs: TriState, 
$ingestObservation: TriState, 
$hasHistoricData: TriState,
$stationMetadataVisible: TriState,
) {
  # Get Station Data
    stationMetaData(
      returnAll:$returnAll,
      zoomLevel: $zoomLevel,
      stationIds: $stationIds,
      hasHistoricData: $hasHistoricData,
      weatherDailyVisible: $weatherDailyVisible, 
      nfdrsDailyVisible: $nfdrsDailyVisible, 
      weatherHourlyVisible: $weatherHourlyVisible, 
      nfdrsHourlyVisible: $nfdrsHourlyVisible, 
      weatherDailyDownload: $weatherDailyDownload, 
      weatherHourlyDownload: $weatherHourlyDownload, 
      nfdrsDailyDownload: $nfdrsDailyDownload, 
      nfdrsHourlyDownload: $nfdrsHourlyDownload, 
      produceNfdrs: $produceNfdrs, 
      ingestObservation: $ingestObservation, 
      stationMetadataVisible: $stationMetadataVisible
    ){
    _metadata{
      page
      per_page
      total_count
      page_count
    }
    data{
      station_id
      fems_station_id
      wrcc_id
      station_name
      latitude
      longitude
      elevation
      time_zone
      time_zone_offset     
      has_historic_data 
      period_record_start
      period_record_stop
      network_name
      state
      nfdr_visibility
      vpd_min
      vpd_max
      vpd_max_percentile
      vpd_min_percentile
    }
    }
  }
`;

export const stationTableQuery = 
`query GetStationTableQuery($stationId: String, 
  $networkName: String, 
  $stateId: String, 
  $agency: String, 
  $sortBy: StationMetadataSortBy, 
  $sortOrder: SortOrder, 
  $page: Int, 
  $perPage: Int, 
  $weatherDailyVisible: TriState, 
  $nfdrsDailyVisible: TriState, 
  $weatherHourlyVisible: TriState, 
  $nfdrsHourlyVisible: TriState, 
  $weatherDailyDownload: TriState, 
  $weatherHourlyDownload: TriState, 
  $nfdrsDailyDownload: TriState, 
  $nfdrsHourlyDownload: TriState, 
  $produceNfdrs: TriState, 
  $ingestObservation: TriState, 
  $hasHistoricData: TriState,
  $stationMetadataVisible: TriState
) {
  # Get Station Data
    stationMetaData(
      stationIds: $stationId,
      networkName: $networkName,
      stateId: $stateId,
      agency: $agency,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      page: $page,
      per_page: $perPage,
      weatherDailyVisible: $weatherDailyVisible, 
      nfdrsDailyVisible: $nfdrsDailyVisible, 
      weatherHourlyVisible: $weatherHourlyVisible, 
      nfdrsHourlyVisible: $nfdrsHourlyVisible, 
      weatherDailyDownload: $weatherDailyDownload, 
      weatherHourlyDownload: $weatherHourlyDownload, 
      nfdrsDailyDownload: $nfdrsDailyDownload, 
      nfdrsHourlyDownload: $nfdrsHourlyDownload, 
      produceNfdrs: $produceNfdrs, 
      ingestObservation: $ingestObservation, 
      hasHistoricData: $hasHistoricData,
      stationMetadataVisible: $stationMetadataVisible
    ){
    _metadata{
      page
      per_page
      total_count
      page_count
    }
    data{
      fems_station_id
      station_id
      station_name
      has_historic_data
      network_id
      network_name
      state
      agency
      time_zone
      time_zone_offset
      period_record_start
      period_record_stop
      latitude
      longitude
      nfdr_visibility
      weather_daily_visible
      nfdrs_daily_visible
      weather_hourly_visible
      nfdrs_hourly_visible
      weather_daily_download
      weather_hourly_download
      nfdrs_daily_download
      nfdrs_hourly_download
      ingest_observation
      station_metadata_visible
      produce_nfdrs
      vpd_min
      vpd_max
      vpd_max_percentile
      vpd_min_percentile
    }
  }
}`;

  export const dataBarbs:BarbHelper[] = [
    {
      minRange: 3,
      maxRange: 8,
      img: kt5,
      symbol: new PictureMarkerSymbol({
          url: kt5,
          height:15,
          width:15,
          xoffset: -16,
      }),
      
    },
    {
      minRange: 9,
      maxRange: 14,
      
      img: kt10,
      symbol: new PictureMarkerSymbol({
        url: kt10,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 15,
      maxRange: 20,
      
      img: kt15,
      symbol: new PictureMarkerSymbol({
        url: kt15,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 21,
      maxRange: 25,
      
      img: kt20,
      symbol: new PictureMarkerSymbol({
        url: kt20,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 26,
      maxRange: 31,
      
      img: kt25,
      symbol: new PictureMarkerSymbol({
        url: kt25,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 32,
      maxRange: 37,
      
      img: kt30,
      symbol: new PictureMarkerSymbol({
        url: kt30,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 38,
      maxRange: 43,
      
      img: kt35,
      symbol: new PictureMarkerSymbol({
        url: kt35,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange:44,
      maxRange: 49,
      
      img: kt40,
      symbol: new PictureMarkerSymbol({
        url: kt40,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 50,
      maxRange: 54,
      
      img: kt45,
      symbol: new PictureMarkerSymbol({
        url: kt45,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 55,
      maxRange: 60,
      
      img: kt50,
      symbol: new PictureMarkerSymbol({
        url: kt50,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 61,
      maxRange: 66,
      
      img:kt55,
      symbol: new PictureMarkerSymbol({
        url: kt55,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 67,
      maxRange: 71,
      
      img:kt60,
      symbol: new PictureMarkerSymbol({
        url: kt60,
        height:15,
        width:15,
        xoffset: -16,
    }),

    },
    {
      minRange: 72,
      maxRange: 77,
      
      img:kt65,
      symbol: new PictureMarkerSymbol({
        url: kt65,
        height:15,
        width:15,
        xoffset: -16,
    }),

    },
    {
      minRange: 78,
      maxRange: 83,
      
      img:kt70,
      symbol: new PictureMarkerSymbol({
        url: kt70,
        height:15,
        width:15,
        xoffset: -16,
    }),

    },
    {
      minRange: 84,
      maxRange: 89,
      
      img: kt75,
      symbol: new PictureMarkerSymbol({
        url: kt75,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 90,
      maxRange: 94,
      
      img: kt80,
      symbol: new PictureMarkerSymbol({
        url: kt80,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 95,
      maxRange: 100,
      
      img: kt85,
      symbol: new PictureMarkerSymbol({
        url: kt85,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 101,
      maxRange: 106,
      
      img: kt90,      
      symbol: new PictureMarkerSymbol({
        url: kt90,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 107,
      maxRange: 112,
      
      img:kt95,
      symbol: new PictureMarkerSymbol({
        url: kt95,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange:113,
      maxRange: 117,
      
      img: kt100,
      symbol: new PictureMarkerSymbol({
        url: kt100,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
    {
      minRange: 119,
      maxRange: 123,
      
      img:kt105,
      symbol: new PictureMarkerSymbol({
        url: kt105,
        height:15,
        width:15,
        xoffset: -16,
    }),
    },
  ]

  export const stationInformationQuery = `query GetStationMetaData($stationId: String!, 
  $weatherDailyVisible: TriState, 
  $nfdrsDailyVisible: TriState, 
  $weatherHourlyVisible: TriState, 
  $nfdrsHourlyVisible: TriState, 
  $weatherDailyDownload: TriState, 
  $weatherHourlyDownload: TriState, 
  $nfdrsDailyDownload: TriState, 
  $nfdrsHourlyDownload: TriState, 
  $produceNfdrs: TriState, 
  $ingestObservation: TriState, 
  $hasHistoricData: TriState,
  $stationMetadataVisible: TriState,
  ) {
    # Get Station Data
      stationMetaData(
        returnAll:false,
        stationIds: $stationId,
        weatherDailyVisible: $weatherDailyVisible, 
        nfdrsDailyVisible: $nfdrsDailyVisible, 
        weatherHourlyVisible: $weatherHourlyVisible, 
        nfdrsHourlyVisible: $nfdrsHourlyVisible, 
        weatherDailyDownload: $weatherDailyDownload, 
        weatherHourlyDownload: $weatherHourlyDownload, 
        nfdrsDailyDownload: $nfdrsDailyDownload, 
        nfdrsHourlyDownload: $nfdrsHourlyDownload, 
        produceNfdrs: $produceNfdrs, 
        ingestObservation: $ingestObservation, 
        hasHistoricData: $hasHistoricData,
        stationMetadataVisible: $stationMetadataVisible
      ){
      _metadata{
        page
        per_page
        total_count
        page_count
      }
      data{
        station_id
        fems_station_id
        network_name
        network_id
        wrcc_id
        state
        has_historic_data
        period_record_start
        period_record_stop
        time_zone
        time_zone_offset
        station_name
        latitude
        longitude
        aspect_direction
        elevation
        avg_annual_precip
        agency
        nfdr_visibility
        weather_daily_visible
        nfdrs_daily_visible
        weather_hourly_visible
        nfdrs_hourly_visible
        weather_daily_download
        weather_hourly_download
        nfdrs_daily_download
        nfdrs_hourly_download
        ingest_observation
        station_metadata_visible
        produce_nfdrs
        vpd_min
        vpd_max
        vpd_max_percentile
        vpd_min_percentile
        fuel_models{
          slopeclass
          grasstype
        }
        
      }
      }
    }
  `;

  export const nfdrCatalogQuery = `query NfdrCatalog($stationId: String) {
    nfdrCatalog(
        returnAll: false
        stationIds: $stationId
    ) {
        _metadata {
            page
            per_page
            total_count
            page_count
        }
        data {
            fire_danger_model_station_id
            fire_danger_model_id
            fire_danger_model_name
            primary_flg
            fems_station_id
            station_id
            wims_id
            fuel_model
            version
            slope_class
            grass_type
            scm
            mxd
            kbdi_parameter_catalog_id
            dead_fuel_parameter_catalog_id
            gsi_parameter_catalog_id
            kbdi_threshold
            kbdi_initial
            kbdi_parameter_catalog_name
            catalog_name
            herb_days_avg
            herb_max_gsi
            herb_greenup
            herb_max
            herb_min
            herb_temp_min_max
            herb_temp_min_min
            herb_vpd_min
            herb_vpd_max
            herb_day_length_min
            herb_day_length_max
            herb_vpd_avg_flg
            woody_days_avg
            woody_max_gsi
            woody_greenup
            woody_max
            woody_min
            woody_temp_min_max
            woody_temp_min_min
            woody_vpd_min
            woody_vpd_max
            woody_day_length_min
            woody_day_length_max
            woody_vpd_avg_flg
            herb_precip_total_min
            herb_precip_total_max
            herb_total_precip_days
            herb_use_precip_flg
            woody_precip_total_min
            woody_precip_total_max
            woody_total_precip_days
            woody_use_precip_flg
            herb_calibration
            woody_calibration
            dead_fuel_parameter_catalog_name
            absorption_rate
            stick_radius_1_hr_fuel_moisture
            stick_radius_10_hr_fuel_moisture
            stick_radius_100_hr_fuel_moisture
            stick_radius_1000_hr_fuel_moisture
            modified_time
            modified_by
            created_time
            created_by
            parent_catalog_name
        }
    }
}
  `;

  export const getAreaQuery = `query GetAreas($returnAll: Boolean!, $areaId: String) {
    getAreas(
        returnAll: $returnAll
        areaId: $areaId
    ) {
        areas{
          areaName
          areaId
          areaContacts {
            priority
            areaContactId
            areaId
            contactId
            modifiedTime
            modifiedBy
            contact {
              contactId
              name
              phoneNumber
              extension
              email
              location
              title
            }
          }
        }
      }
    }`;

  export const createUpdateGroupQuery = `mutation CreateUpdateGroup(
    $groupId: Int,
    $groupName: String,
    $areaId: String,
    $status: String,
    $groupContacts: [CreateUpdateGroupContactInput]
    $deleteGroupContacts: [CreateUpdateGroupContactInput]
    ) {
    createUpdateGroup(
      groupId: $groupId,
      groupName: $groupName,
      areaId: $areaId,
      status: $status,
      groupContacts: $groupContacts    
      deleteGroupContacts: $deleteGroupContacts     
    ) {
      groupId
      areaId
      areaName
      groupName
      groupStatus
      createDate
      lastModifiedBy
      lastModifiedDate
      deleteCount
      groupContacts {
        groupContactId
        contactId
        contactName
        contactPhoneNumber
        contactExtension
        contactEmail
        priority
      }
    }
  }`;

  export const getGroupQuery = `query GetGroup($returnAll: Boolean!, $filterByArea: String, $sortBy: String, $sortOrder: String ) {
    getGroups(
        filterByArea: $filterByArea
        returnAll: $returnAll
        sortBy: $sortBy
        sortOrder: $sortOrder
    ) {
      groupDetails{
        groupId
        groupName
        status
        area{
          areaName
          areaId
        }
      }
    }
  }`;
  
  export const getGroupTableQuery =`query GetGroupTable($returnAll: Boolean!, $groupId: Int, $filterByGroup: String, $filterByArea: String,$filterByStatus: String,$page: Int,$perPage: Int,  $sortBy: String, $sortOrder: String) {
    getGroups(
      returnAll: $returnAll
      groupId: $groupId
      filterByGroup: $filterByGroup
      filterByArea: $filterByArea
      filterByStatus: $filterByStatus
      sortBy: $sortBy
      sortOrder: $sortOrder
      page: $page
      perPage: $perPage
    ) {
      pageInfo{
        page
        per_page
        page_count
        total_count
      }
      groupDetails {
        groupId
        groupName
        status
        area{
            areaName
            areaId
            areaContacts {
              contactId
              name
              priority
            }
        }
        groupContacts{
          groupContactId
          contactId
          name
          phoneNumber
          extension
          email
          priority
        }
      }
    }
  }`;

  export const getSitesQuery = `query GetSitesforGroup($returnAll: Boolean!, 
    $groupId: Int,
    $siteId: String, 
    $siteKey: String,
    ) {
    getSites(
        returnAll: $returnAll
        groupId: $groupId
        siteId: $siteId
        siteKey: $siteKey
    ) {
        sites {
            groupId 
            groupName
            siteId
            siteName
            active
            longitude
            latitude
            elevation
            remarks
            areaName
            areaId
            jurisdiction
            siteStatus
            timeZone
            timeZoneOffset
        }
    }
  }`;

  export const getSiteKeySearchBarQuery = `query GetSiteKeys {
    getSiteKeys{
      site_id
      site_name
      site_key
      display_key
    }
  }`;

  export const getCodesQuery = `query GetCodeTables(
    $returnAll: Boolean!, 
    $type: String,
    $page: Int,
    $per_page: Int) {
    getCodeTables(
        returnAll: $returnAll
        type: $type
        page: $page
        per_page: $per_page
    ) {
        pageInfo{
            page
            per_page
            total_count
            page_count
        }
        codes{
            code_table_id
            type
            code_key
            code_value
        }
    }
}`;

export const getSampleHeaderQuery = `query GetSampleHeaders(
  $returnAll: Boolean!,
  $siteId: String
  $startDate: DateTime
  $endDate: DateTime
  $filterByFuelId: String
  $filterBySampleType: String
  $filterByStatus: String
  $filterByCategory: String
  $filterBySubCategory: String
  $filterByMethod: String
  $sortBy: String,
  $sortOrder: String,
  $page: Int
  $perPage: Int
) {
  getSampleHeaders(
      returnAll: $returnAll,
      siteId: $siteId
      startDate: $startDate
      endDate: $endDate
      filterByFuelId: $filterByFuelId
      filterBySampleType: $filterBySampleType
      filterByStatus: $filterByStatus
      filterByCategory: $filterByCategory
      filterBySubCategory: $filterBySubCategory
      filterByMethod: $filterByMethod
      sortBy: $sortBy
      sortOrder: $sortOrder
      page: $page
      perPage: $perPage) {
          pageInfo {
              page
              per_page
              total_count
              page_count
          }
          sampleHeaders {
              site_id
              siteName
              fuelId
              fuel_type
              category
              sub_category
              method
              latestSampleDate
          }
  }
}`;

export const getUniqueFuel = `query GetUniqueFuels(
  $startDate: DateTime!
  $endDate: DateTime!
  $filterByStatus: String
  $filterByCategory: String
  $filterBySubCategory: String
  $filterByMethod: String
  $filterByFuel: String
  $sortBy: String
  $sortOrder: String
  $page: Int
  $perPage: Int
) {
  getUniqueFuels(
      startDate: $startDate
      endDate: $endDate
      filterByStatus: $filterByStatus
      filterByCategory: $filterByCategory
      filterBySubCategory: $filterBySubCategory
      filterByMethod: $filterByMethod
      filterByFuel: $filterByFuel
      sortBy: $sortBy
      sortOrder: $sortOrder
      page: $page
      perPage: $perPage
  ) {
    pageInfo {
        page
        per_page
        total_count
        page_count
    }
    uniqueFuelSamples {
        fuelType
        category
        subCategory
        method
        firstSampleDate
        latestSampleDate
    }
  }
}`;


export const getSiteMetaDataQuery = `query GetSiteMetaData($returnAll: Boolean!, 
  $fuelSampleMetadataInput: FuelSampleMetadataInputDTO,
  $groupId: Int,
  $siteId: String, 
  $siteKey: String,
  $page: Int,
  $perPage: Int) {
    getSites(
      fuelSampleMetadataInput: $fuelSampleMetadataInput
      returnAll: $returnAll
      groupId: $groupId
      siteId: $siteId
      siteKey: $siteKey
      page: $page
      perPage: $perPage
  ) {
      pageInfo{
          page
          per_page
          page_count
          total_count
      }
      sites {
          siteId
          siteStartDate
          createdTime
          siteName
          siteStatus
          active
          longitude
          latitude
          elevation
          remarks
          jurisdiction
          slope
          aspect
          stateName
          stateId
          groupId
          groupName
          areaName
          areaId
          timeZone
          timeZoneOffset
          fuelSampleMetadata {
            firstSampleDate
            latestSampleDate
            latestSampleDateInRange
            latestSampleAverageInRange
        }
      }
  }
}` ;

export const getSitesforMap = `query GetSiteForMap($returnAll: Boolean!, 
  $perPage: Int,
  $fuelSampleMetadataInput: FuelSampleMetadataInputDTO
  $zoomLevel: Int
  ) {
    getSites(
      fuelSampleMetadataInput: $fuelSampleMetadataInput
      zoomLevel: $zoomLevel
      returnAll: $returnAll
      perPage: $perPage
  ) {
      pageInfo{
          page
          per_page
          page_count
          total_count
      }
      sites {
          siteId
          siteStartDate
          siteName
          siteStatus
          longitude
          active
          latitude
          elevation
          latestSampleDate
          timeZone
          timeZoneOffset
          fuelSampleMetadata {
            firstSampleDate
            latestSampleDate
            latestSampleDateInRange
            latestSampleAverageInRange
        }
      }
  }
}` ;

export const getSampleFilteredQuery= `query GetFuelSamples($returnAll: Boolean!,
  $sampleId: Int,
  $siteId: String,
  $startDate: DateTime
  $endDate: DateTime
  $filterBySampleType: String,
  $filterByStatus: String,
  $filterByCategory: String,
  $filterBySubCategory: String,
  $filterByMethod: String,
  $sortBy: String,
  $sortOrder: String,
  $page: Int,
  $perPage: Int,
  ) {
  getFuelSamples(
      returnAll: $returnAll
      sampleId: $sampleId
      siteId: $siteId
      startDate: $startDate
      endDate: $endDate
      filterBySampleType: $filterBySampleType
      filterByStatus: $filterByStatus
      filterByCategory: $filterByCategory
      filterBySubCategory: $filterBySubCategory
      filterByMethod: $filterByMethod
      sortBy: $sortBy
      sortOrder: $sortOrder
      page: $page
      perPage: $perPage
       
  ) {
      pageInfo{
          page
          per_page
          page_count
          total_count
      }
      fuelSamples {
        fuel_sample_id
        site_id
        fuel{
          fuel_type 
          category
        }
        sub_category
        sample
        subSampleCount
        method_type
        status
        sample_average_value
      }
  }
}`;

export const getSubSampleQuery = `query GetSubSamples($returnAll: Boolean!, $sample_id: Int) {
  getSubSamples(
      returnAll: $returnAll
      sample_id: $sample_id
      page: null
      per_page: null
  ) {
      pageInfo{
          page
          per_page
          total_count
          page_count
      }
      fuelSubSamples {
          fuel_sub_sample_id
          fuel_sample_id
          status 
          sample_average_value 
          tar_weight
          dry_weight
          wet_weight
          modified_time
          created_time
          created_by
          container_id
      }
  }
}`;

export const getAllStates = `query FindAllStates {
  findAllStates {
      state_id
      state_name
  }
}`;

/* below is getContacts the call is slow. For the call to get all the info of contact search directory we don't need areaName or groupName*/
export const getContacts = `
  query GetContacts(
    $returnAll: Boolean!,
    $contactId: Int,
    $filterByName: String,
    $filterByLocation: String,
    $filterByTitle: String,
    $filterByArea: String,
    $filterByGroup: String,
    $sortBy: String,
    $sortOrder: String,
    $page: Int,
    $perPage: Int
  ) {
    getContacts(
        returnAll: $returnAll,
        contactId: $contactId
        filterByName: $filterByName,
        filterByLocation: $filterByLocation,
        filterByTitle: $filterByTitle,
        filterByArea: $filterByArea,
        filterByGroup: $filterByGroup,
        sortBy: $sortBy,
        sortOrder: $sortOrder,
        page: $page,
        perPage: $perPage   
    ) {
      pageInfo{
        page
        per_page
        page_count
        total_count
    }
      contacts{
        contactId
        contactName
        contactPhone
        contactExtension
        location
        contactEmail
        modifiedTime
        modifiedBy
        createdTime
        createdBy
        title
        areas{
          areaName
        }
        groups {
          groupName
        }
      }
    }
  }
`

export const mutateSampleQuery = `mutation CreateUpdateSample(
  $site_id: Int,
  $fuel_sample_id: Int,
  $fuel_type: String,
  $category: String,
  $sub_category: String,
  $method: String,
  $sample_status: String,
  $sample_datetime: DateTime,
  $sample_average_value: Float
  ) {
  createUpdateSample(
      site_id: $site_id,
      fuel_sample_id: $fuel_sample_id,
      fuel_type: $fuel_type,
      category: $category,
      sub_category: $sub_category,
      method: $method,
      sample_status: $sample_status,
      sample_datetime: $sample_datetime,
      sample_average_value: $sample_average_value
  )
  {
      fuel_sample_id
      fuel_type
      category
      sub_category
      method
      sample_average_value
      sample_datetime
  }
}

`;

export const getFuelsQuery = `query GetFuels(
  $returnAll: Boolean!,
  $fuel_id: Int,
  $fuel_type: String,
  $category: String
  ) {
  getFuels(
      returnAll: $returnAll
      fuel_id: $fuel_id
      fuel_type: $fuel_type
      category: $category

  ){
      fuel_id
      category
      fuel_type
  }
}`;

export const mutateSubSampleQuery = `mutation CreateFuelSubSamples(
  $sub_sample: [FuelSubSampleInput],
  $sample_id: Int
) {
  createFuelSubSamples(
      sub_sample: $sub_sample,
      sample_id: $sample_id
       ) {
      fuel_sub_sample_id
      fuel_sample_id
      status
      sample_average_value
      tar_weight
      dry_weight
      wet_weight
      modified_time
      modified_by
      container_id
  }
}`;

export const deleteSubSampleQuery = `mutation DeleteFuelSubSample(
  $fuel_sub_sample_id: Int!
){
      deleteFuelSubSample(
          fuel_sub_sample_id: $fuel_sub_sample_id
      )
  }`
;  

export const deleteSampleQuery = `mutation DeleteFuelSample (
  $sample_id: Int!
){
  deleteFuelSample(
      sample_id: $sample_id
  )
}`;

export const mutateAreaQuery = `mutation CreateUpdateArea(
  $areaId: String,
  $areaName: String,
  $mapCenterLat: Float,
  $mapCenterLong: Float,
  $mapWidth: Int,
  $mapHeight: Int,
  $zoomLevel:Int
  $areaContacts: [CreateUpdateAreaContactInput]
  $deleteAreaContacts: [CreateUpdateAreaContactInput]

  ) {
  createUpdateArea(
    areaId: $areaId,
    areaName: $areaName,
    mapCenterLat: $mapCenterLat,
    mapCenterLong: $mapCenterLong,
    mapWidth: $mapWidth,
    mapHeight: $mapHeight,
    zoomLevel: $zoomLevel
    areaContacts: $areaContacts
    deleteAreaContacts: $deleteAreaContacts
  ) {
    areaId
    areaName
    creationDate
    lastModifiedBy
    lastModifiedDate
    deleteCount
    areaContacts {
        areaContactId
        areaId
        contactId
        contactName
        contactPhoneNumber
        contactEmail
        priority
    }
  }
   
}`;

export const mutationContactQuery = `mutation CreateUpdateContacts(
  $contactId: Int,
  $name: String,
  $phone: String,
  $extension: String,
  $email: String
  $location: String
  $title: String
  ) {
    createUpdateContacts(
      contactId: $contactId
      name: $name
      phone: $phone
      extension: $extension
      email: $email
      location: $location
      title: $title
    ) {
      contactId
      contactName
      contactPhone
      contactExtension
      contactEmail
      location
      title
      modifiedTime 
      modifiedBy
      createdTime  
    }
}`;


export const mutationSiteQuery = `mutation CreateUpdateSites(
  $siteId: Int,
  $siteStartDate: DateTime,
  $active: Int,
  $siteName: String,
  $groupId: Int!,
  $stateId: String!,
  $jurisdiction: String,
  $longitude:Float,
  $latitude: Float,
  $elevation: Int,
  $remarks: String
  ) {
  createUpdateSites(
      siteId: $siteId,
      siteStartDate: $siteStartDate,
      active: $active,
      siteName: $siteName,
      groupId: $groupId,
      stateId: $stateId,
      jurisdiction: $jurisdiction,
      longitude: $longitude,
      latitude: $latitude,
      elevation: $elevation,
      remarks: $remarks     
  )
  {
    siteId
    siteStartDate
    siteName
    latitude
    longitude
    elevation
    remarks
    jurisdiction
    createdTime
    modifiedTime
    modifiedBy
    slope
    aspect
    stateName
    rawsId
    raws
    stateId
    stateName
    groupName
    areaId
    areaName
    active
    groupId
  }
}`;

export const getAuditTrailItems= `query GetAuditTrailItems(
  $auditTrailItemId: Int,
  $entityType: String,
  $entityId: String,
  $auditType: String,
  $auditField: String,
  $activityStartDate: String,
  $activityEndDate: String) {
  getAuditTrailItems(
      auditTrailItemId: $auditTrailItemId
      entityType: $entityType
      entityId: $entityId
      auditType: $auditType
      auditField: $auditField
      activityStartDate: $activityStartDate
      activityEndDate: $activityEndDate
  ){
        auditTrailItemId
        entityType
        entityId
        auditType
        auditField
        description
        createdBy
        createdTime
        modifiedBy
        modifiedTime
 }
}`;
export const getBulkFileNames = `query GetBulkDataFileNames {
  getBulkDataFileNames {
      fileName
  }
}`;

export const getBulkDataJobs = `query GetBulkDataJobs(
  $returnAll: Boolean!,
  $status: String,
  $fileName: String,
  $uploadStartDate: String,
  $uploadEndDate: String,
  $sortBy: String,
  $sortOrder: String,
  $perPage: Int,
  $page: Int,
) {
  getBulkDataJobs(
      returnAll: $returnAll
      status: $status
      fileName: $fileName
      uploadStartDate: $uploadStartDate
      uploadEndDate: $uploadEndDate
      sortBy: $sortBy
      sortOrder: $sortOrder
      perPage: $perPage
      page: $page
  ) {
      pageInfo {
          page
          per_page
          total_count
          page_count
      }
      bulkDataJobs {
          bulkDataJobId
          fileName
          jobType
          jobStatus
          fileLocation
          fileSize
          completionTime
          modifiedTime
          modifiedBy
          createdTime
          createdBy
      }
  }
}
`
export const uploadFieldSampleData = `mutation UploadFieldSampleData(
  $fileName: String!,
  $fileType: String,
  $fileFormat: String,
  $fileContents: String,
  $fileSize: String!
) {
  uploadFieldSampleData(
      fileName: $fileName
      fileType: $fileType
      fileFormat: $fileFormat
      fileContents: $fileContents
      fileSize: $fileSize
  ) {
      jobId
      status
  }
}
`

export const deleteContactQuery = `mutation DeleteContact($contactId: Int!){
  deleteContact(
      contactId: $contactId
  )
}`;


export const getNfdrWithoutTimeQuery = `query GetNfdrMinMaxWithoutTime($stationIds: String, $startDate:Date!, $endDate: Date, $page: Int, $per_page: Int, $fuelModel: String, $zoomLevel: Int, $hasHistoricData: TriState, $visibilitySettings: TriState) {
  # get nfdr min max
    nfdrMinMax(
      stationIds: $stationIds,
      startDate: $startDate,
      fuelModels: $fuelModel,
      zoomLevel: $zoomLevel,
      hasHistoricData: $hasHistoricData,
      endDate: $endDate,
      page: $page,
      per_page: $per_page,
      visibilitySettings: $visibilitySettings
    ){
    _metadata{
      page
      per_page
      total_count
      page_count
    }
    data{
      station_id
      station_name
			summary_date
      nfdr_type
      fuel_model
      one_hr_tl_fuel_moisture_min
      ten_hr_tl_fuel_moisture_min
      hun_hr_tl_fuel_moisture_min
      thou_hr_tl_fuel_moisture_min
      ignition_component_max
      spread_component_max
      energy_release_component_max
      burning_index_max
      herbaceous_lfi_fuel_moisture
      woody_lfi_fuel_moisture
      gsi
      kbdi
      quality_code
    }
  }
}`;

export const nfdrMinMaxWithTimeQuery =`query GetNfdrMinMaxWithTime($stationIds: String, $startDate:Date!, $endDate: Date, $sortBy: NfdrMinMaxSortBy, $sortOrder: SortOrder, $page: Int, $per_page: Int, $fuelModel: String, $zoomLevel: Int, $hasHistoricData: TriState, $visibilitySettings: TriState) {
  # get nfdr min max
    nfdrMinMax(
      stationIds: $stationIds,
      startDate: $startDate,
      fuelModels: $fuelModel,
      zoomLevel: $zoomLevel,
      endDate: $endDate,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      hasHistoricData: $hasHistoricData,
      page: $page,
      per_page: $per_page,
      visibilitySettings: $visibilitySettings
    ){
    _metadata{
      page
      per_page
      total_count
      page_count
    }
    data{
      station_id
      station_name
      summary_date
      nfdr_type
      fuel_model
      one_hr_tl_fuel_moisture_min
      one_hr_tl_fuel_moisture_min_time
      ten_hr_tl_fuel_moisture_min
      ten_hr_tl_fuel_moisture_min_time
      hun_hr_tl_fuel_moisture_min
      hun_hr_tl_fuel_moisture_min_time
      thou_hr_tl_fuel_moisture_min
      thou_hr_tl_fuel_moisture_min_time
      ignition_component_max
      ignition_component_max_time
      spread_component_max
      spread_component_max_time
      energy_release_component_max
      energy_release_component_max_time
      burning_index_max
      burning_index_max_time
      herbaceous_lfi_fuel_moisture
      woody_lfi_fuel_moisture
      gsi
      kbdi
      quality_code
    }
  }
}`;


export const nfdrHourlyQuery = 
  `query GetNfdrHourly(
    $stationIds: String, 
    $fuelModel: String!, 
    $startDateRange:Date, 
    $endDateRange: Date,
    $startHour:Int, 
    $endHour:Int, 
    $dateTimeFormat: DateTimeFormat,
    $zoomLevel: Int, 
    $nfdrType: String,
    $hasHistoricData: TriState,
    $sortBy: NfdrObsSortBy, 
    $sortOrder: SortOrder, 
    $page: Int, 
    $per_page: Int,
    $visibilitySettings: TriState
  ) {
  # get nfdr hourly
    nfdrsObs(
      zoomLevel: $zoomLevel,
      stationIds: $stationIds,
      fuelModels: $fuelModel,
      startDateRange: $startDateRange, 
      endDateRange: $endDateRange,
      startHour: $startHour,
      endHour: $endHour,
      dateTimeFormat: $dateTimeFormat,
      sortBy: $sortBy,
      sortOrder: $sortOrder,
      page: $page,
      per_page: $per_page,
      nfdrType: $nfdrType,
      hasHistoricData: $hasHistoricData,
      visibilitySettings: $visibilitySettings
    ){
    _metadata{
      page
      per_page
      total_count
      page_count
    }
    data{
      station_id
      station_name
			observation_time
      observation_time_lst
      display_hour
      display_hour_lst
      nfdr_type
      fuel_model
  		one_hr_tl_fuel_moisture
      ten_hr_tl_fuel_moisture
      hun_hr_tl_fuel_moisture
      thou_hr_tl_fuel_moisture
      ignition_component
      spread_component
      energy_release_component
      burning_index
      herbaceous_lfi_fuel_moisture
      woody_lfi_fuel_moisture
      gsi
      kbdi
      quality_code
    }
  }
}`;

export const dailySampleAvgQuery = `query GetAverages(
  $siteId: Int!
  $filterByFuelType: String,
  $filterByStatus: String,
  $filterByCategory: String,
  $filterBySubCategory: String,
  $filterByMethod: String,
  $page: Int,
  $perPage: Int,
  ){
  getDailyFuelSampleSav(
      siteId: $siteId
      filterByFuelType: $filterByFuelType
      filterByStatus: $filterByStatus
      filterByCategory: $filterByCategory
      filterByMethod: $filterByMethod
      filterBySubCategory: $filterBySubCategory
      page: $page
      perPage: $perPage
  ) {
      pageInfo {
          page
          per_page
          total_count
          page_count
      }
      dailyFuelSampleSav {
          siteId
          fuelType
          methodType
          category
          subCategory
          sampleDate
          dailyAverageSav
          dailyMinSav
          dailyMaxSav
          dailySampleCount
      }
  }
}`;

export const historicalFieldSampleDailiesQuery =`query HistoricalAvgMinMax(
  $dateTimeFormat: String,
  $endMonthDay: String,
  $endYear: String,
  $startMonthDay: String,
  $startYear: String,
  $siteId: Int!,
  $category: String,
  $method: String,
  $sampleType: String,
  $subCategory: String,
  $status: String) {
  historicalAvgMinMax(
      dateTimeFormat: $dateTimeFormat
      endMonthDay: $endMonthDay
      endYear: $endYear
      startMonthDay: $startMonthDay
      startYear: $startYear
      siteId: $siteId
      category: $category
      method: $method
      sampleType: $sampleType
      subCategory: $subCategory
      status: $status
  ){
        siteId
        day
        sampleAverageValue {
            min
            max
            avg
            
        }
 }
}`;

export const mainQuery = `energy_release_component_max {
  min
  max
  avg
  
}
spread_component_max {
  min
  max
  avg
  
}
ignition_component_max {
  min
  max
  avg
  
}
burning_index_max {
  min
  max
  avg
  
}
one_hr_tl_fuel_moisture_min {
  min
  max
  avg
  
}
ten_hr_tl_fuel_moisture_min{
  min
  max
  avg
  
}
hun_hr_tl_fuel_moisture_min {
  min
  max
  avg
  
}
thou_hr_tl_fuel_moisture_min {
  min
  max
  avg
  
}
herbaceous_lfi_fuel_moisture_max{
  min
  max
  avg
  
}
woody_lfi_fuel_moisture_max {
  min
  max
  avg
  
}
kbdi_max {
  min
  max
  avg
  
}
gsi_max {
  min
  max
  avg
  
}
 vapor_press_def_max {
  min
  max
  avg
  
}
  vapor_press_def_min {
  min
  max
  avg
  
}

`;

export const percentileLevelsQuery = `query GetPercentileLevels(
  $stationId: String!
  $fuelModel: FuelModelTypes!
  $startYear: ClimatologyYear
  $endYear: ClimatologyYear
  $startMonthDay: ClimatologyMonthDay
  $endMonthDay: ClimatologyMonthDay
  $startHour: TimeHour
  $endHour: TimeHour
  $percentileLevels: String
  $dateTimeFormat: DateTimeFormat
  $visibilitySettings: TriState
  ){
  percentileLevels(
    stationIds: $stationId
    fuelModel: $fuelModel
    visibilitySettings: $visibilitySettings
    climatology: {
        startYear: $startYear
        endYear: $endYear
        startMonthDay: $startMonthDay
        endMonthDay: $endMonthDay
        startHour: $startHour
        endHour: $endHour
        dateTimeFormat: $dateTimeFormat
    }
    percentileLevels: $percentileLevels
    page: 0
    per_page: 300000
  ) {
    _metadata {
        page
        per_page
        total_count
        page_count
    }
    data {
      station_id
      kbdi_max
      one_hr_tl_fuel_moisture_min
      ten_hr_tl_fuel_moisture_min
      hun_hr_tl_fuel_moisture_min
      thou_hr_tl_fuel_moisture_min
      ignition_component_max
      spread_component_max
      energy_release_component_max
      woody_lfi_fuel_moisture_max
      herbaceous_lfi_fuel_moisture_max
      burning_index_max
      vapor_press_def_max
      vapor_press_def_min
    }
  }
}`;

export const getClimatologyCodeTable = `query getClimatologyCodeTable(
  $returnAll: Boolean!, 
  $type: String,
  $page: Int,
  $per_page: Int) {
  codeTable(
      returnAll: $returnAll
      type: $type
      page: $page
      per_page: $per_page
  ) {
      _metadata{
          page
          per_page
          total_count
          page_count
      }
      data{
          code_table_id
          type
          code_key
          code_value
      }
  }
}`

export const mutateApiKey = `mutation CreateUpdateApiKey(
    $apiKey: String
) {
  createUpdateApiKey(apiKey: $apiKey) {
      message
      data
  }
}`

export const mutateStationMeta = `mutation UpdateStationMetadata($stationId: Int,$vpd_max_percentile: Int, $vpd_min_percentile: Int, $avg_annual_precip: Float, $weather_daily_visible: Boolean,
$nfdrs_daily_visible: Boolean, $weather_hourly_visible: Boolean,$nfdrs_hourly_visible: Boolean,
$weather_daily_download: Boolean,$weather_hourly_download: Boolean,$nfdrs_hourly_download: Boolean,$nfdrs_daily_download: Boolean,
$produce_nfdrs: Boolean,$ingest_observation: Boolean,$station_metadata_visible: Boolean
){
    updateStationMetadata(
        vpd_min_percentile: $vpd_min_percentile,
        vpd_max_percentile: $vpd_max_percentile,
        avg_annual_precip: $avg_annual_precip,
        weather_daily_visible: $weather_daily_visible, 
        nfdrs_daily_visible: $nfdrs_daily_visible,
        weather_hourly_visible: $weather_hourly_visible,
        nfdrs_hourly_visible: $nfdrs_hourly_visible,
        weather_daily_download: $weather_daily_download,
        weather_hourly_download: $weather_hourly_download,
        nfdrs_hourly_download: $nfdrs_hourly_download,
        nfdrs_daily_download: $nfdrs_daily_download,
        produce_nfdrs: $produce_nfdrs,
        ingest_observation: $ingest_observation,
        station_metadata_visible: $station_metadata_visible,
        station_id: $stationId
    ) {
        message
        data
    }
}`;

export const mutateReportQuery = `mutation CreateUpdatePowerBIReport($id: Int,$title:String, $description: String, $type: PowerBIReportType, $url:String, $visible: Boolean){
    createUpdatePowerBIReport(
        id: $id,
        title: $title, 
        description: $description,
        type: $type, 
        url: $url
        visible: $visible
    ) {
        message
        data
    }
}`;

export const deleteReportQuery = `mutation DeletePowerBIReport($id: Int!) {
    deletePowerBIReport(id: $id) {
        message
    }
}`;

export const getReportsQuery =`query GetPowerBIReports($sortBy: GetPowerBIReportSortBy, 
  $sortOrder: SortOrder, $page: Int, $perPage: Int, $type: PowerBIReportType, $id:Int, $visible: TriState
) {
    getPowerBIReports(
        sortBy: $sortBy
        sortOrder: $sortOrder
        page: $page
        per_page: $perPage
        type: $type
        id: $id
        visible: $visible
    ) {
        _metadata {
            page
            per_page
            total_count
            page_count
        }
        data {
            id
            title
            description
            type
            url
            visible
            createdBy
            createdTime
            modifiedBy
            modifiedTime
        }
    }
}`;

export const getFuelModelCatalogs = `query GetFuelModelCatalog($sortBy: FuelModelCatalogSortBy, 
  $sortOrder: SortOrder, $page: Int, $perPage: Int, $catalogName: String, $id:Int, $fuelModel: FuelModelTypesWithAll) {
    getFuelModelCatalog(
        sortBy: $sortBy
        sortOrder: $sortOrder
        page: $page
        per_page: $perPage
        catalogName: $catalogName
        id: $id
        fuelModel: $fuelModel
    ) {
        _metadata {
            page
            per_page
            total_count
            page_count
        }
        data {
            catalogId
            fireDangerModelName
            fuelModel
            slopeClass
            grassType
            mxdOverride
            scm
            stations
            droughtCatalog {
                id
                name
            }
            liveFuelCatalog {
                id
                name
            }
            deadFuelCatalog {
                id
                name
            }
            catalogName
        }
    }
  }`;

export const getDeadCatalogs = `  query GetDeadFuelCatalog($sortBy: DeadFuelModelCatalogSortBy, 
  $sortOrder: SortOrder, $page: Int, $perPage: Int, $id:Int) {
    getDeadFuelCatalog(
        sortBy: $sortBy
        sortOrder: $sortOrder
        page: $page
        per_page: $perPage
        id: $id
    )
    {
      _metadata {
        page
        per_page
        total_count
        page_count 
      }
      data {
        id
        catalogName
        stickRadius1HrFuelMoisture
        stickRadius10HrFuelMoisture
        stickRadius100HrFuelMoisture
        stickRadius1000HrFuelMoisture 
      } 
    } 
  }`

  export const getDroughtCatalogs = `query GetDroughtCatalog(
    $id: Int,
    $sortBy: DroughtCatalogSortBy,
    $sortOrder: SortOrder,
    $page: Int,
    $perPage: Int,
    ) {
    getDroughtCatalogs(
        id: $id
        sortBy: $sortBy
        sortOrder: $sortOrder
        page: $page
        per_page: $perPage
    ) {
		_metadata{
            page
            per_page
            page_count
            total_count
        }
        data {
		      id
          name
          kbdiInitial
          kbdiThreshold
          modifiedTime
          modifiedBy
          createdTime
          createdBy
		  }
    }
}`;

export const getLiveCatalogs = `query GetLiveFuelCatalog(
    $id: Int,
    $sortBy: GetLiveFuelCatalogSortBy,
    $sortOrder: SortOrder,
    $page: Int,
    $perPage: Int,
    ) {
    getLiveFuelCatalog(
        id: $id
        sortBy: $sortBy
        sortOrder: $sortOrder
        page: $page
        per_page: $perPage
    ) {
        _metadata {
            page
            per_page
            total_count
            page_count
        }
        data {
            gsiParameterCatalogId
            catalogName
            herbDaysAvg
            herbMaxGsi
            herbGreenup
            herbMax
            herbMin
            herbTempMinMax
            herbTempMinMin
            herbVpdMin
            herbVpdMax
            herbDayLengthMin
            herbDayLengthMax
            herbVpdAvgFlg
            woodyDaysAvg
            woodyMaxGsi
            woodyGreenup
            woodyMax
            woodyMin
            woodyTempMinMax
            woodyTempMinMin
            woodyVpdMin
            woodyVpdMax
            woodyDayLengthMin
            woodyDayLengthMax
            woodyVpdAvgFlg
            herbPrecipTotalMin
            herbPrecipTotalMax
            herbTotalPrecipDays
            herbUsePrecipFlg
            woodyPrecipTotalMin
            woodyPrecipTotalMax
            woodyTotalPrecipDays
            woodyUsePrecipFlg
            herbCalibration
            woodyCalibration
        }
    }
}`;

export const createUpdateDeadFuelCatalogQuery = `mutation CreateUpdateDeadFuelCatalog(
    $id: Int,
    $name: String,
    $hr1StickRadius: Float,
    $hr10StickRadius: Float,
    $hr100StickRadius: Float,
    $hr1000StickRadius: Float
    ) {
    createUpdateDeadFuelCatalog(
        id: $id
        name: $name
        hr1StickRadius: $hr1StickRadius
        hr10StickRadius: $hr10StickRadius
        hr100StickRadius: $hr100StickRadius
        hr1000StickRadius: $hr1000StickRadius
    ) {
        data
        
    }
}`;

export const createUpdateDroughtCatalogQuery = `mutation CreateUpdateDroughtCatalog(
    $id: Int,
    $catalogName: String,
    $kbdiInitial: Int,
    $kbdiThreshold: Int
    ) {
    createUpdateDroughtCatalog(
        id: $id
        catalogName: $catalogName
        kbdiInitial: $kbdiInitial
        kbdiThreshold: $kbdiThreshold
    ) {
        data
        message
    }
}`;


export const createUpdateFuelModelCatalogQuery = `mutation createUpdateFireDangerModelCatalog($fireDangerModelCatalog: [fireDangerModelCatalog!]!) {
  createUpdateFireDangerModelCatalog(fireDangerModelCatalog: $fireDangerModelCatalog) {
      message
      data
  }
}`;
export const createUpdateLiveFuelCatalogMutation = 
`mutation CreateUpdateLiveFuelCatalog(
  $id: Int
  $name: String!
  $herbDaysAvg: Int!
  $herbMaxGsi: Float!
  $herbGreenup: Float!
  $herbMax: Int!
  $herbMin: Int!
  $herbTempMinMax: Int!
  $herbTempMinMin: Int!
  $herbVpdMin: Int!
  $herbVpdMax: Int!
  $herbDayLengthMin: Int!
  $herbDayLengthMax: Int!
  $herbVpdAvgFlg: String!
  $woodyDaysAvg: Int!
  $woodyMaxGsi: Float!
  $woodyGreenup: Float!
  $woodyMax: Int!
  $woodyMin: Int!
  $woodyTempMinMax: Int!
  $woodyTempMinMin: Int!
  $woodyVpdMin: Int!
  $woodyVpdMax: Int!
  $woodyDayLengthMin: Int!
  $woodyDayLengthMax: Int!
  $woodyVpdAvgFlg: String!
  $herbPrecipTotalMin: Float!
  $herbPrecipTotalMax: Float!
  $herbTotalPrecipDays: Int!
  $herbUsePrecipFlg: String!
  $woodyPrecipTotalMin: Float!
  $woodyPrecipTotalMax: Float!
  $woodyTotalPrecipDays: Int!
  $woodyUsePrecipFlg: String!
  $herbCalibration: String!
  $woodyCalibration: String!
  ) {
    createUpdateLiveFuelCatalog(
        id: $id
        name: $name
        herbDaysAvg: $herbDaysAvg
        herbMaxGsi: $herbMaxGsi
        herbGreenup: $herbGreenup
        herbMax: $herbMax
        herbMin: $herbMin
        herbTempMinMax: $herbTempMinMax
        herbTempMinMin: $herbTempMinMin
        herbVpdMin: $herbVpdMin
        herbVpdMax: $herbVpdMax
        herbDayLengthMin: $herbDayLengthMin
        herbDayLengthMax: $herbDayLengthMax
        herbVpdAvgFlg: $herbVpdAvgFlg
        woodyDaysAvg: $woodyDaysAvg
        woodyMaxGsi: $woodyMaxGsi
        woodyGreenup: $woodyGreenup
        woodyMax: $woodyMax
        woodyMin: $woodyMin
        woodyTempMinMax: $woodyTempMinMax
        woodyTempMinMin: $woodyTempMinMin
        woodyVpdMin: $woodyVpdMin
        woodyVpdMax: $woodyVpdMax
        woodyDayLengthMin: $woodyDayLengthMin
        woodyDayLengthMax: $woodyDayLengthMax
        woodyVpdAvgFlg: $woodyVpdAvgFlg
        herbPrecipTotalMin: $herbPrecipTotalMin
        herbPrecipTotalMax: $herbPrecipTotalMax
        herbTotalPrecipDays: $herbTotalPrecipDays
        herbUsePrecipFlg: $herbUsePrecipFlg
        woodyPrecipTotalMin: $woodyPrecipTotalMin
        woodyPrecipTotalMax: $woodyPrecipTotalMax
        woodyTotalPrecipDays: $woodyTotalPrecipDays
        woodyUsePrecipFlg: $woodyUsePrecipFlg
        woodyCalibration: $woodyCalibration
        herbCalibration: $herbCalibration
    ) {
        data
    }
}`;

export const deleteLiveFuelCatalogMutation = 
`mutation DeleteLiveFuelCatalog($id: Int!) {
  deleteLiveFuelCatalog(id: $id) {
    message
  }
}`;

export const deleteDeadFuelCatalogMutation = 
`mutation DeleteDeadFuelCatalog($id: Int!) {
  deleteDeadFuelCatalog(id: $id) {
    message
  }
}`;

export const deleteDroughtCatalogMutation = 
`mutation DeleteDroughtCatalog($id: Int!) {
  deleteDroughtCatalog(id: $id) {
    message
  }
}`;

export const getStatusRecalcQuery = `query GetRecalcStatus(
    $stationName: String,
    $fuelModelCatalogName: String, 
    $droughtCatalogName: String, 
    $liveCatalogName: String, 
    $deadCatalogName: String,  
    $sortBy: RecalcStatusSortBy,
    $sortOrder: SortOrder,
    $page: Int,
    $perPage: Int,
    ) {
    getRecalcStatus(
        stationName: $stationName
        fuelModelCatalogName: $fuelModelCatalogName 
    	  droughtCatalogName: $droughtCatalogName
    	  liveCatalogName: $liveCatalogName
    	  deadCatalogName: $deadCatalogName  
        sortBy: $sortBy
        sortOrder: $sortOrder
        page: $page
        per_page: $perPage
    ) {
		_metadata{
            page
            per_page
            page_count
            total_count
        }
        data {
		    stationName
        fuelModelCatalogName
        catalogName
        droughtCatalogName
        liveCatalogName
        deadCatalogName
        comments
        status
        modifiedTime
        modifiedBy
        createdTime
        createdBy
		}
    }
}`;

export const deleteFireDangerModelCatalogMutation = 
`mutation DeleteFireDangerModelCatalog($id: Int!) {
  deleteFireDangerModelCatalog(id: $id) {
    message
  }
}`;

export const getQueueDownloadJobsStatusQuery = 
`query ExportJobStatus(
  $jobIds: [compositeId],
  $sortBy: ExportStatusSortBy,
  $hideStaleJobs: Boolean,
  $sortOrder: SortOrder,
  $page: Int,
  $per_page: Int
) {
    exportJobStatus(
    hideStaleJobs: $hideStaleJobs,
    jobIds: $jobIds,
    sortBy: $sortBy, 
    sortOrder: $sortOrder,
    page: $page,
    per_page: $per_page
    ) {
      _metadata {
        page
        per_page
        total_count
        page_count
      }
        data {
            id
            jobId
            status
            progress
            queueName
            fileName
            timeStarted
            completedTime
            userName
            errorMessage
        }
    }
}`;


export const getCalcResultsQuery = `query CalculatorService(
      $stationId: Int!,
      $windSpeed: Int!,
      $temperature: Int!,
      $solarRadiation: Float!,
      $relativeHumidity: Float!,
      $precipitation: Float!,
      $snowFlag: SnowFlagType!,
      $fuelModel: FuelModelTypes!
    ) {
        calculatorService(
        stationId: $stationId, 
        fuelModel: $fuelModel, 
        temperature: $temperature, 
        windSpeed: $windSpeed, 
        solarRadiation: $solarRadiation, 
        relativeHumidity: $relativeHumidity, 
        precipitation: $precipitation, 
        snowFlag: $snowFlag
        ) {
            data {
            intermediateValues {
                observationTime
                observationTimeLST
                hr1FM
                hr10FM
                hr100FM
                hr1000FM
                woodyFM
                herbFM
                kbdi
                fuelTemperature
                gsi
            }
            indices {
                bi
                erc
                sc
                ic
            }
        }
    }
}
`;

export const auditLogClimQuery =`query GetAuditTrailItems(
$activityStartDate: Date, 
$activityEndDate: Date, 
$auditField: String, 
$auditTrailItemId: Int, 
$auditType: String, 
$entityId: Int, 
$entityType: String, 
$sortBy: AuditTrailItemsSortBy, 
$sortOrder: SortOrder, 
$page: Int, 
$perPage: Int
) {
  getAuditTrailItems(
  activityStartDate: $activityStartDate, 
  activityEndDate: $activityEndDate, 
  auditField: $auditField, 
  auditTrailItemId: $auditTrailItemId, 
  auditType: $auditType, 
  entityId: $entityId, 
  entityType: $entityType, 
  sortBy: $sortBy, 
  sortOrder: $sortOrder, 
  page: $page, 
  per_page: $perPage
  ) {
    _metadata {
      page
      per_page
      total_count
      page_count
    }
    data {
      id
      entityType
      entityId
      auditType
      auditField
      description
      modifiedTime
      modifiedBy
      createdTime
      createdBy
    }
  }
}`;

export const getWeatherRelatedNFDRSQuery =`query GetWeatherRelatedNFDRS(
    $stationId: Int!,
    $fuelModel: FuelModelTypes!,
    $startDate: Date,
    $endDate: Date,
    $dateTimeFormat: DateTimeFormat,
    $endHour: Int,
    $startHour: Int
) {
    getWeatherRelatedNFDRS(
        stationId: $stationId
        fuelModel: $fuelModel
        dateTimeFormat: $dateTimeFormat
        startDate: $startDate
        endDate: $endDate
        startHour: $startHour
        endHour: $endHour
    ) {
        _metadata {
            per_page
            total_count
            page_count
        }
        data {
            observation_time
            observation_time_lst
            display_hour
            display_hour_lst
            temperature
            sol_radiation
            relative_humidity
            hourly_precipitation
            wind_speed
            wind_direction
            peak_gust_speed
            peak_gust_dir
            snow_flag
            one_hr_tl_fuel_moisture
            ten_hr_tl_fuel_moisture
            hun_hr_tl_fuel_moisture
            thou_hr_tl_fuel_moisture
            herbaceous_lfi_fuel_moisture
            woody_lfi_fuel_moisture
            kbdi
            gsi
            fuel_temperature
        }
    }
}`;